import zhLocale from "../../../node_modules/element-ui/lib/locale/lang/zh-CN";
const zh = {
  // 头部
  navbar: {
    home: "首页",
    list: [
      {
        name: "账户信息",
        type: 1,
        img: require("../../assets/img/login/account.png")
      },
      {
        name: "退出登录",
        type: 3,
        img: require("../../assets/img/login/out.png")
      }
    ],
    logOut: "退出登录",
    accountInformation: "账户信息",
    login: "登录",
    register: "注册",
    ProductSystem: "产品体系",
    solution: "解决方案",
    price: "价格",
    AboutUs: "关于我们",
    title: "创造无限连接",
    dropList: [
      // {
      //   name: "DCI互联",
      //   names: "SD-DCI",
      //   img1: require("../../assets/img/header/DCI.png"),
      //   img: require("../../assets/img/header/DCI.png"),
      //   imgs: require("../../assets/img/header/DCI2.png"),
      //   type: 1
      // },
      {
        name: "MSP",
        names: "MSP",
        img1: require("../../assets/img/header/DCI.png"),
        img: require("../../assets/img/header/DCI.png"),
        imgs: require("../../assets/img/header/DCI2.png"),
        type: 1
      },
      {
        name: "云专线",
        names: "SD-Cloud 1",
        img1: require("../../assets/img/header/cloud1.png"),
        img: require("../../assets/img/header/cloud1.png"),
        imgs: require("../../assets/img/header/cloud.png"),
        type: 2
      },
      {
        name: "定向加速",
        names: "DA",
        img1: require("../../assets/img/header/speed.png"),
        img: require("../../assets/img/header/speed.png"),
        imgs: require("../../assets/img/header/speed2.png"),
        type: 3
      },
      {
        name: "SD-WAN",
        names: "SD-WAN",
        img1: require("../../assets/img/header/SD-WAN.png"),
        img: require("../../assets/img/header/SD-WAN.png"),
        imgs: require("../../assets/img/header/SD-WAN2.png"),
        type: 4
      }
    ],
    solutList: [
      {
        name: "混合云方案",
        img1: require("../../assets/img/header/headhunhe.png"),
        img: require("../../assets/img/header/headhunhe.png"),
        imgs: require("../../assets/img/header/headhunhe2.png"),
        type: 1
      },
      {
        name: "企业私有网",
        img1: require("../../assets/img/header/headsiyou.png"),
        img: require("../../assets/img/header/headsiyou.png"),
        imgs: require("../../assets/img/header/headsiyou2.png"),
        type: 2
      }
    ],
    aboutus: [
      {
        name: "公司简介",
        img1: require("../../assets/img/header/conpy1.png"),
        img: require("../../assets/img/header/conpy1.png"),
        imgs: require("../../assets/img/header/conpy2.png"),
        type: 1
      },
      {
        name: "新闻资讯",
        img1: require("../../assets/img/header/news1.png"),
        img: require("../../assets/img/header/news1.png"),
        imgs: require("../../assets/img/header/news2.png"),
        type: 3
      },
      {
        name: "服务承诺",
        img1: require("../../assets/img/header/serve1.png"),
        img: require("../../assets/img/header/serve1.png"),
        imgs: require("../../assets/img/header/serve2.png"),
        type: 2
      }
    ]
  },
  // 底部
  footer: {
    Services: "联系我们",
    phonetext: "7*24*365小时保障电话：",
    telphone: "400-8768-711",
    address: "地址：北京市朝阳区酒仙桥东路14号院A5楼412室",
    email: "邮箱：noc@tianchic.com",
    saleemail: "销售邮箱：sales@tianchic.com",
    productSystem: "产品体系",
    DCIInterconnected: "DCI互联",
    CloudLine: "云专线",
    DirectionalAcceleration: "定向加速",
    SDWAN: "SD-WAN",
    solution: "解决方案",
    cloud: "混合云方案",
    conty: "企业私有网",
    about: "关于我们",
    intro: "公司简介",
    service: "服务承诺",
    weixin: "扫一扫关注我们"
  },
  // 首页
  main: {
    title: "高速 稳定 安全",
    text: "基于天弛SDN高可用网络，打造DC-DC、DC-云、云-云之间无障碍连接网络",
    texttitle:
      "天弛网络致力于打造国内领先的生态网络服务，坚持以客户至上、创新务实、不忘初心、以诚为本的企业价值观",
    texttitles:
      "基于行业特性，天弛网络以安全为先，稳定为本，整合行业资源，为各行业提供针对性解决方案，布局生态网络平台",
    product: "产品介绍",
    textlist: [
      {
        name: "MSP",
        img: require("../../assets/img/main/DCI.png"),
        title:
          "基于天弛与国内外多家云厂家的深入合作，为客户提供不同云厂家从云咨询到云监控的多场景云系统服务能力。",
        btn: "了解更多",
        type: 1
      },
      {
        name: "云专线",
        img: require("../../assets/img/main/cloud.png"),
        title:
          "提供的高速、安全、稳定的专线连接服务，基于天弛网络SDN平台满足网内不同地域POP节点-公有云、公有云-公有云的互联需求。",
        btn: "了解更多",
        type: 2
      },
      {
        name: "定向加速",
        img: require("../../assets/img/main/JS.png"),
        title:
          "定向加速是天弛网络提供的高速、安全、稳定的专线连接服务，基于天弛网络SDN平台满足网内不同地域定向加速需求",
        btn: "了解更多",
        type: 3
      },
      {
        name: "SD-WAN",
        img: require("../../assets/img/main/SD-WAN.png"),
        title:
          "提供的高速、安全、稳定的连接服务，基于天弛网络SD-WAN网络满足网内不同地域互联需求。",
        btn: "了解更多",
        type: 4
      }
    ],
    case: "客户案例",
    caselist: [
      {
        name: "MSP产品案例",
        img: require("../../assets/img/main/DCIcase.png"),
        title:
          "基于天弛与国内外多家云厂家的深入合作，为客户提供不同云厂家从云咨询到云监控的多场景云系统服务能力",
        type: 1
      },
      {
        name: "云专线产品案例",
        img: require("../../assets/img/main/cloudCase.png"),
        title: "帮助企业快速构建高质量的连接公有云的专有网络",
        type: 2
      },

      {
        name: "定向加速产品案例",
        img: require("../../assets/img/main/speedCase.png"),
        title: "基于天弛SDN高可用网络平台满足客户不同定向加速的需求",
        type: 3
      },
      {
        name: "SD-WAN产品案例",
        img: require("../../assets/img/main/SD-WANcase.png"),
        title:
          "基于天弛SD-WAN高可用网络满足客户总部与分支机构的互联需求，帮助企业快速组网",
        type: 4
      }
    ],
    create: "创造无限连接",
    partner: "坚持合作与服务至上",
    serve: "服务客户",
    join: "合作伙伴",
    overseas: "海外合作基础设施",
    open: "已开发区域",
    data: [
      {
        name: "中国",
        value: [104.195397, 35.86166, 1],
        data: ""
      },
      {
        name: "日本",
        value: [139.252924, 39.204824],
        data: ""
      },
      {
        name: "韩国",
        value: [127.766922, 35.907757],
        data: ""
      },
      {
        name: "法国",
        value: [2.213749, 45.227638],
        data: ""
      },
      {
        name: "德国",
        value: [14.451526, 48.165691],
        data: ""
      },
      {
        name: "美国",
        value: [-95.712891, 37.09024],
        data: ""
      },
      {
        name: "英国",
        value: [-2.235973, 56.378051],
        data: ""
      },
      {
        name: "荷兰",
        value: [5.291265999999999, 52.132633],
        data: ""
      },
      {
        name: "新加坡",
        value: [101.975766, 4.210484],
        data: ""
      }
    ]
  },
  // 产品体系-DCI
  // projectdci: {
  //   title: "DCI互联",
  //   text: "数据中心之间专线互联，高速畅达",
  //   textlist: [
  //     {
  //       name: "高速互通",
  //       img: require("../../assets/img/product/spes.png")
  //     },
  //     {
  //       name: "稳定可靠",
  //       img: require("../../assets/img/product/stab.png")
  //     },
  //     {
  //       name: "安全",
  //       img: require("../../assets/img/product/save.png")
  //     },
  //     {
  //       name: "按需购买",
  //       img: require("../../assets/img/product/buy.png")
  //     }
  //   ],
  //   header: "DCI简介",
  //   matter:
  //     "DCI业务是天弛网络提供的高速、安全、稳定的专线连接服务，基于天弛网络SDN网络满足网内不同地域DC-DC的互联需求。帮助企业快速构建高质量私有网络，实现DCI等多种场景的网络融合",
  //   about:
  //     "依靠天弛网络SDN高可用网络技术，可以将不同厂商公有云连通，两侧直接进行高速内网通信，不再需要绕行公网。即使两侧远隔千里，也可以享受到内网通信一般的低延迟和高带宽",
  //   feature: "产品特色",
  //   about2:"天弛网络SDN高可用网络产品依托天弛全球骨干网基础设施实现，保障您的网络间通信稳定可靠",
  //   about3:"天弛SDN高可用网络在网络虚拟化层通信，所有通信数据在天弛网络自建设施中传输，且多租户互相隔离，让您的私密数据免去传输过程中被窃取的风险",
  //   about4:"天弛SDN高可用网络产品提供不同带宽的规格。您可以根据您的业务需求按需购买，成本可控",
  //   spelist: [
  //     {
  //       name: "单点接入，全网贯通",
  //       img: require("../../assets/img/product/04.png"),
  //       title:
  //         "连接天弛的任一节点即可获得与多个网络提供应用商的连接条件。企业通过扩容带宽即可满足业务增量需求，避免建设多条链路"
  //     },
  //     {
  //       name: "多地域接入",
  //       img: require("../../assets/img/product/05.png"),
  //       title:
  //         "天弛提供覆盖华北、华东、华南、港澳台及海外的100多个POP节点，企业可根据自身业务需求选择就近节点接入"
  //     },
  //     {
  //       name: "可视化管理",
  //       img: require("../../assets/img/product/06.png"),
  //       title: "在线自助开通，业务可视化管理"
  //     },
  //     {
  //       name: "快速开通",
  //       img: require("../../assets/img/product/01.png"),
  //       title: "最快3天建立DC节点直连"
  //     },
  //     {
  //       name: "按需配置",
  //       img: require("../../assets/img/product/02.png"),
  //       title: "1Mbps-10Gbps同带宽可调支持弹性增长"
  //     },
  //     {
  //       name: "实时监测",
  //       img: require("../../assets/img/product/03.png"),
  //       title: "实时网络监控及监测提供流量报告"
  //     }
  //   ],
  //   scene: "应用场景",
  //   menustitle: "两地三中心容灾",
  //   text2: [
  //     {
  //       title:
  //         "通过天弛DCI产品，在同城数据中心节点上建立备份，可以实现服务和数据快速恢复；在异地数据中心节点上建立备份，避免发生自然灾害等意外时导致数据丢失"
  //     }
  //   ],
  //   menustitles: "解决的问题",
  //   menulists: [
  //     {
  //       title: "全程采用天弛SDN高可用网络，实现两地三中心互联，保证数据实时同步"
  //     },
  //     {
  //       title: "全面保障服务和数据安全，提升服务可用率"
  //     }
  //   ],
  //   case: "客户案例",
  //   demand: "客户需求",
  //   serviceList: [
  //     {
  //       name: "客户北京和上海分别有数据中心，需要实时数据备份"
  //     }
  //   ],
  //   solution: "解决方案",
  //   serviceLists: [
  //     {
  //       name: "客户两地数据中心均在天弛SDN高可用网络的POP节点上"
  //     },
  //     {
  //       name: "通过两地数据中心机房内跳线，客户设备接入天弛SDN高可用网络上"
  //     },
  //     {
  //       name:
  //         "客户可以实现数据实时备份，可快速恢复，避免发生自然灾害等意外时导致数据丢失"
  //     }
  //   ]
  // },
  // msp
  projectdci: {
    title: "MSP",
    text: "一站式云系统迁移、部署、监控服务",
    textlist: [
      {
        name: "云咨询",
        img: require("../../assets/img/product/spes.png")
      },
      {
        name: "云部署",
        img: require("../../assets/img/product/stab.png")
      },
      {
        name: "云迁移",
        img: require("../../assets/img/product/save.png")
      },
      {
        name: "云监控",
        img: require("../../assets/img/product/yun.png")
      }
    ],
    header: "MSP简介",
    matter:
      "基于天弛与国内外多家云厂家的深入合作，为客户提供不同云厂家从云咨询到云监控的多场景云系统服务能力",
    about:
      "从客户接触到产品选型阶段提供专业化的产品使用指导，同时在业务系统设计方案提供成熟的方案设计体系",
    feature: "产品特色",
    about2:
      "面向业务应用的落地实施操作，可以针对客户业务架构进行相对应的应用部署操作。满足在多种场景模块的部署方案",
    about3:
      "针对混合云、IDC上云、云数据迁移等不同场景设计针对性操作方案及迁云管理，实现用户低损或无损迁移操作",
    about4:
      "根据客户使用的业务应用给出相对应的监控方案，配合云上的监控及拨测做到多方面的问题发现",
    spelist: [
      {
        name: "多场景的技术支撑能力",
        img: require("../../assets/img/product/04.png"),
        title: ""
      },
      {
        name: "全方面的应用部署能力",
        img: require("../../assets/img/product/05.png"),
        title: ""
      },
      {
        name: "成熟的架构迁移能力",
        img: require("../../assets/img/product/06.png"),
        title: ""
      },
      {
        name: "可靠的问题发现能力",
        img: require("../../assets/img/product/02.png"),
        title: ""
      }
      // {
      //   name: "按需配置",
      //   img: require("../../assets/img/product/02.png"),
      //   title: "1Mbps-10Gbps同带宽可调支持弹性增长"
      // },
      // {
      //   name: "实时监测",
      //   img: require("../../assets/img/product/03.png"),
      //   title: "实时网络监控及监测提供流量报告"
      // }
    ],
    scene: "应用场景",
    menustitle: "按迁移方案划分",
    text2: [
      {
        title:
          "热迁移：需要建设专线进行明确的模块迁移规划，耗时长业务影响低，迁云风险系数大。"
      },
      {
        title:
          "冷迁移：可接受有损的业务切换，可在集成测试后进行全量切换，迁移时间周期较短，迁云风险系数低。"
      }
    ],
    menustitles: "按迁移场景划分",
    menulists: [
      {
        title:
          "跨云迁移：不同云产品功能及设备类型适配，在售前POC阶段需要进行大量的功能性测试。"
      },
      {
        title:
          "IDC迁移：最常见的迁云模式，仅需要确认IDC业务调用逻辑，设备适配可按照云厂家方案提供，迁移难度较小。"
      }
    ],
    case: "客户案例",
    demand: "客户需求",
    serviceList: [
      {
        name:
          "【MSP售前场景】针对腰部及中长尾的小型金融客户需要使用云上和本地资源做混合云以及本地私有化部署的场景需要提供专业的产品使用和选型建议，以及架构设计方案的咨询；"
      },
      {
        name:
          "【MSP售中场景】对于已经确认使用云或私有化部署，但是需要进行部署和迁移服务时没有人力和操作经验金融客户；"
      }
    ],
    solution: "解决方案",
    serviceLists: [
      {
        name:
          "售前阶段提供专业的服务部署咨询服务，引导用户按模块、服务做后业务分拆实现高内聚低耦合高可用架构逻辑；"
      },
      {
        name:
          "售中过程提供一站式的业务部署服务，助力金融客户在多云环境和IDC环境下的逻辑层和数据层和网络层的部署简单完成；"
      }
    ]
  },
  projectcloud: {
    title: "云专线",
    text:
      "天弛网络提供高速、安全、稳定的云专线服务，实现数据中心、私有云、公有云之间的专线网络连接",
    textlist: [
      {
        name: "高速互通",
        img: require("../../assets/img/product/spes.png")
      },
      {
        name: "稳定可靠",
        img: require("../../assets/img/product/stab.png")
      },
      {
        name: "安全",
        img: require("../../assets/img/product/save.png")
      },
      {
        name: "按需购买",
        img: require("../../assets/img/product/buy.png")
      }
    ],
    header: "云专线简介",
    matter:
      "云专线是天弛提供的高速、安全、稳定的专线连接服务，基于天弛骨干网满足网内不同地域POP节点-POP节点、POP节点-公有云、公有云-公有云的互联需求。 结合最后一公里连接服务，可将云专线延伸至用户写字楼或数据中心，帮助企业快速构建高质量私有网络，实现DCI、ECI等多种场景的网络融合",
    about:
      "依靠天弛网络SDN高可用网络技术，可以将不同厂商公有云连通，两侧直接进行高速内网通信，不再需要绕行公网。即使两侧远隔千里，也可以享受到内网通信一般的低延迟和高带宽",
    about2:
      "天弛网络SDN高可用网络产品依托天弛全球骨干网基础设施实现，保障您的网络间通信稳定可靠",
    about3:
      "天弛SDN高可用网络在网络虚拟化层通信，所有通信数据在天弛网络自建设施中传输，且多租户互相隔离，让您的私密数据免去传输过程中被窃取的风险",
    about4:
      "天弛SDN高可用网络产品提供不同带宽的规格。您可以根据您的业务需求按需购买，成本可控",
    feature: "产品特色",
    spelist: [
      {
        name: "单点接入，全网贯通",
        img: require("../../assets/img/product/04.png"),
        title:
          "连接天弛的任一节点，即可获得与多个网络供应商的连接条件，企业通过扩容带宽即可满足业务增量需求，避免建设多条链路"
      },
      {
        name: "多地域接入",
        img: require("../../assets/img/product/05.png"),
        title:
          "天弛提供覆盖华北、华东、华南、港澳台及海外的100多个POP节点，企业可根据自身业务需求选择就近节点接入"
      },
      {
        name: "多场景接入",
        img: require("../../assets/img/product/07.png"),
        title:
          "云专线产品支持阿里云、腾讯云、AWS等主流公有云、IDC节点之间的两两互联，满足企业多场景的专线连接需求"
      },
      {
        name: "快速开通",
        img: require("../../assets/img/product/01.png"),
        title:
          "SDN高可用网络与公有云、私有云、行业云平台API自动化对接全面支持混合云网络虚拟专线互联客户自服务系统，支持一键操作、秒级开通"
      },
      {
        name: "按需配置",
        img: require("../../assets/img/product/02.png"),
        title:
          "支持固定宽带包月的计费策略支持基于宽带+时长的计费策略支持基于流量的计费策略"
      },
      {
        name: "实时监测",
        img: require("../../assets/img/product/03.png"),
        title: "实时网络监控及监测，提供流量报告"
      }
    ],
    scene: "应用场景",
    menustitle: "双云双活架构",
    text2: [
      {
        title:
          "基于天弛骨干网络与公有云资源，通过线上自助实现跨云环境的网络融合，助力双云双活架构快速落地"
      }
    ],
    menustitles: "解决的问题",
    menulists: [
      {
        title:
          "全程采用专线连接，保证网络稳定、高速，数据实时同步，提升用户体验"
      },
      {
        title: "通过天弛SDN高可用网络平台按需调度网络资源，实现网络的弹性分配"
      }
    ],
    case: "客户案例",
    demand: "客户需求",
    serviceList: [
      {
        name: "客户需要从某地公有云到某地公有云做直连云业务"
      },
      {
        name: "需要2条1G链路或者1条2G链路，确认不同方案和报价"
      },
      {
        name:
          "2条1G链路需要具备不同的传输路径，实现冗余互备，同时做负载均衡；或2条2G链路具备不同的传输路径，实现冗余互备"
      },
      {
        name:
          "稳定底层线路——通过城网稳定可靠的特点，提供全面冗余高可用的网络架构"
      }
    ],
    solution: "解决方案",
    serviceLists: [
      {
        name: "天弛SDN高可用网络与公有云、私有云、行业云平台API自动化对接"
      },
      {
        name: "天弛SDN高可用网络全面支持混合云网络虚拟专线互联"
      },
      {
        name: "客户数据直接经由天弛SDN高可用网络实现公有云之间互联"
      },
      {
        name: "客户业务通过天弛SDN高可用网络实现公有云之间互通"
      },
      {
        name: "链路备份，确保故障点降至最少"
      }
    ]
  },
  projectDA: {
    title: "定向加速",
    text: "本地接入天弛SDN高可用网络直达资源池",
    textlist: [
      {
        name: "高速互通",
        img: require("../../assets/img/product/spes.png")
      },
      {
        name: "稳定可靠",
        img: require("../../assets/img/product/stab.png")
      },
      {
        name: "安全",
        img: require("../../assets/img/product/save.png")
      },
      {
        name: "按需购买",
        img: require("../../assets/img/product/buy.png")
      }
    ],
    header: "定向加速简介",
    matter:
      "定向加速是天弛网络提供的高速、安全、稳定的专线连接服务，基于天弛SDN高可用网络满足网内不同地域定向加速需求",
    about:
      "依靠天弛网络SDN高可用网络技术，可以将不同厂商公有云连通，两侧直接进行高速内网通信，不再需要绕行公网。即使两侧远隔千里，也可以享受到内网通信一般的低延迟和高带宽",
    about2:
      "天弛网络SDN高可用网络产品依托天弛全球骨干网基础设施实现，保障您的网络间通信稳定可靠",
    about3:
      "天弛SDN高可用网络在网络虚拟化层通信，所有通信数据在天弛网络自建设施中传输，且多租户互相隔离，让您的私密数据免去传输过程中被窃取的风险",
    about4:
      "天弛SDN高可用网络产品提供不同带宽的规格。您可以根据您的业务需求按需购买，成本可控",
    feature: "产品特色",
    spelist: [
      {
        name: "单点接入，全网贯通",
        img: require("../../assets/img/product/04.png"),
        title:
          "连接天弛的任一节点即可获得与多个网络提供应用商的连接条件。企业通过扩容带宽即可满足业务增量需求，避免建设多条链路"
      },
      {
        name: "多地域接入",
        img: require("../../assets/img/product/05.png"),
        title:
          "天弛提供覆盖华北、华东、华南、港澳台及海外的100多个POP节点，企业可根据自身业务需求选择就近节点接入"
      },
      {
        name: "可视化管理",
        img: require("../../assets/img/product/06.png"),
        title: "在线自助开通，业务可视化管理"
      },
      {
        name: "快速开通",
        img: require("../../assets/img/product/01.png"),
        title: "最快三天建立连接"
      },
      {
        name: "按需配置",
        img: require("../../assets/img/product/02.png"),
        title: "1Mbps-10Gbps同带宽可调支持弹性增长"
      },
      {
        name: "实时监测",
        img: require("../../assets/img/product/03.png"),
        title: "实时网络监控及监测提供流量报告"
      }
    ],
    scene: "应用场景",
    menustitle: "",
    text2: [],
    menustitles: "定向加速",
    menulists: [
      {
        title:
          "采用天弛SDN高可用网络连接直接接入应用，提升网络连接质量，降低网络延迟和丢包率，保证客户的良好应用体验"
      },
      {
        title:
          "通过天弛SDN高可用网络进行网络资源的配置与弹性管理，承载高并发访问压力"
      },
      {
        title:
          "天弛在全球多地区部署IDC节点、互联云节点，能支持全球同服架构的部署"
      },
      {
        title:
          "基于天弛骨干网络架构，提供安全隧道，并结合DDoS高防，保证网络传输安全"
      }
    ],
    case: "客户案例",
    demand: "客户需求",
    serviceList: [
      {
        name: "两端地址 - A-end：沈阳 Z-end：深圳"
      },
      {
        name: "沈阳至深圳要求供应商POP之间时延小于85ms"
      },
      {
        name: "提供端到端带宽1G链路"
      },
      {
        name: "深圳端可以提供接入腾讯云服务器"
      }
    ],
    solution: "解决方案",
    serviceLists: [
      {
        name: "天弛通过专线将沈阳机房与深圳POP节点进行打通"
      },
      {
        name: "天弛提供深圳本地互联网出口，用于沈阳网吧用户访问深圳游戏使用"
      },
      {
        name: "当地网吧可以通过专线或者本地互联网接入深圳机房"
      },
      {
        name: "网吧出口需要有设备可以区分本地游戏（网络）路由和深圳游戏路由"
      },
      {
        name: "所有深圳路由通过天弛提供专线进行访问"
      }
    ]
  },
  projectsd: {
    title: "SD-WAN",
    text: "部署企业轻松WAN管理服务",
    textlist: [
      {
        name: "高速互通",
        img: require("../../assets/img/product/spes.png")
      },
      {
        name: "稳定可靠",
        img: require("../../assets/img/product/stab.png")
      },
      {
        name: "安全",
        img: require("../../assets/img/product/save.png")
      },
      {
        name: "按需购买",
        img: require("../../assets/img/product/buy.png")
      }
    ],
    header: "SD-WAN简介",
    matter:
      "SD-WAN是天弛网络提供的高速、安全、稳定的连接服务，基于天弛网络SD-WAN网络满足网内不同地域互联需求。帮助企业快速构建高质量私有网络，实现办公室加速和大型集团公司组网等多种场景",
    about:
      "依靠天弛网络SDN高可用网络技术，可以将不同厂商公有云连通，两侧直接进行高速内网通信，不再需要绕行公网。即使两侧远隔千里，也可以享受到内网通信一般的低延迟和高带宽",
    about2:
      "天弛网络SDN高可用网络产品依托天弛全球骨干网基础设施实现，保障您的网络间通信稳定可靠",
    about3:
      "天弛SDN高可用网络在网络虚拟化层通信，所有通信数据在天弛网络自建设施中传输，且多租户互相隔离，让您的私密数据免去传输过程中被窃取的风险",
    about4:
      "天弛SDN高可用网络产品提供不同带宽的规格。您可以根据您的业务需求按需购买，成本可控",
    feature: "产品特色",
    spelist: [
      {
        name: "单点接入，全网贯通",
        img: require("../../assets/img/product/04.png"),
        title:
          "连接天弛的任一节点即可获得与多个网络提供应用商的连接条件。企业通过扩容带宽即可满足业务增量需求，避免建设多条链路"
      },
      {
        name: "多地域接入",
        img: require("../../assets/img/product/05.png"),
        title:
          "天弛提供覆盖华北、华东、华南、港澳台及海外的100多个POP节点，企业可根据自身业务需求选择就近节点接入"
      },
      {
        name: "网络管理简单",
        img: require("../../assets/img/product/08.png"),
        title:
          "通过集中式portal自动部署流量规则，使用一个简单界面设置和管理各种网络连接，实现实时网络状况可视化，零接触配置快速部署"
      },
      {
        name: "快速部署",
        img: require("../../assets/img/product/09.png"),
        title: "客户网络接入SD-WAN设备后，自动开通"
      },
      {
        name: "按需配置",
        img: require("../../assets/img/product/02.png"),
        title: "1Mbps-10Gbps同带宽可调支持弹性增长"
      },
      {
        name: "实时监测",
        img: require("../../assets/img/product/03.png"),
        title: "实时网络监控及监测，提供流量报告"
      }
    ],
    scene: "应用场景",
    menustitle: "",
    text2: [],
    menustitles: "大型公司组网",
    menulists: [
      {
        title:
          "例如某大型集团公司在全国地区拥有多家分公司，采用天弛SD-WAN网络实现集团组网"
      },
      {
        title:
          "客户端部署一台SD-WAN的CE设备，就近以接入在的互联的SD-WAN POP节点上"
      },
      {
        title:
          "使用天弛SD-WAN CE设备，基于Internet实现各分公司与天弛SD-WAN的POP点的 “最后一公里”连接"
      }
    ],
    case: "客户案例",
    demand: "客户需求",
    serviceList: [
      {
        name: "通过天弛SD-WAN网络提供跨地域、跨网传输"
      }
    ],
    solution: "解决方案",
    serviceLists: [
      {
        name: "在用户核心（总部或IDC）部署CPE节点"
      },
      {
        name: "分支机构通过现有互联网，与天弛POP节点建立隧道"
      },
      {
        name: "通过天弛SDN高可用网络实现各个节点之间互联互通"
      }
    ]
  },
  // 解决方案
  cloudSolution: {
    title: "混合云方案",
    text: "打造云端无障碍连接",
    header: "混合云解决方案",
    master:
      "依托天弛网络云连接的公有云、数据中心等混合云产品，提供混合云基础设施的设计、部署实施、安全管理和智能运维的全生命周期服务，帮助企业轻松快速搭建自己所需要的混合云架构",
    businessRequire: "业务需求",
    businessList: [
      {
        name: "实现公有云与数据中心、私有云等不同资源的高效互通"
      },
      {
        name:
          "将中心化的公有云资源与能力实现本地化，提高计算效率，从而提升应用体验"
      },
      {
        name:
          "混合云网络架构较为复杂，简化混合云基础设施的落地过程，且对网络质量的要求较高"
      }
    ],
    solutions: "解决方案",
    solutionList: [
      {
        name:
          "基于天弛云专线的公有云集群，深度融合天弛网络的连接能力、混合云产品服务能力，打造混合云产业新生态，助力数据容灾备份解决方案等的快速落地"
      },
      {
        name:
          "为企业提供混合云基础设施设计、部署与实施、安全与智能运维的全生命周期服务，使企业轻松快速定制混合云方案"
      }
    ],
    advantage: "优势",
    textlist: [
      {
        name: "可用性",
        img: require("../../assets/img/solute/01.png"),
        title:
          "云计算并不能保证服务永远正常，但公有云通常会比大多数本地基础设施具有更高的可用性。云内置有冗余功能并提供关键数据的geo-replication",
        type: 1
      },
      {
        name: "敏捷性",
        img: require("../../assets/img/solute/02.png"),
        title:
          "混合云使您能够将资源和工作负载从本地迁移到云，反之亦然。对于开发和测试而言，混合云使开发人员能够轻松搞定新的虚拟机和应用程序，而无需IT运维人员的协助",
        type: 2
      },
      {
        name: "降低成本",
        img: require("../../assets/img/solute/03.png"),
        title:
          "降低成本是云计算最吸引人的优势之一，也是驱使企业管理层考虑云服务的重要因素。混合云可以帮助企业降低成本，利用“即用即付”云计算资源来消除购买本地资源的需求",
        type: 3
      },

      {
        name: "可扩展性",
        img: require("../../assets/img/solute/04.png"),
        title:
          "混合云为企业扩展存储提供了经济高效的方式，云存储的成本相比等量本地存储要低得多，是备份、复制VM和数据归档的不错选择。除此之外，增加云存储没有前置成本和本地资源需求",
        type: 4
      }
    ],
    serve: "一站式混合云服务",
    matterservice:
      "天弛提供专业的业务咨询、数据中心托管、专线网络互联、互联网带宽、硬件代购及代维等服务，满足不同行业的网络需求，一站式解决企业的网络困扰",
    mixtureline: "混合云专线",
    mixturezoo: "混合云生态",
    mixedcoud:
      "通过调用API，在天弛SDN高可用网络中实现公有云之间的互联，无需线下操作，即可实现混合云私有网络的敏捷交付，此外，还可实现企业、数据中心与云的快速连接",
    ecology:
      "天弛网内连接主流云服务商，并与阿里云、腾讯云等公有云服务商合作深度定制混合云完整解决方案"
  },
  contySolution: {
    title: "企业私有网",
    text: "公司总部与分公司组网的高速互通",
    header: "企业私有网",
    master:
      "天弛基于SD-WAN骨干网资源，提供企业总部与分支组网服务，实现不同地区、 不同规模的分支机构间的高速、高质量通信，打造安全、协同、互联的办公网络，大幅提升企业与分支机构的业务互通效率",
    businessRequire: "业务需求",
    businessList: [
      {
        name: "保证企业网的安全性与保密性，避免内部数据外泄"
      },
      {
        name: "实现总部与各分支之间的资源共享与数据实时同步，更好的保证协同工作"
      }
    ],
    solutions: "解决方案",
    solutionList: [
      {
        name:
          "借助天弛广泛覆盖的全球POP节点，实现企业就近接入，并完成大陆及海外各自区域内分支机构的互联"
      },
      {
        name:
          "基于庞大的公有云、数据中心等资源，提供混合网络架构、跨数据中心专线互联与混合云专线互联服务，实现灵活一体的基础设施环境"
      }
    ],
    advantage: "优势",
    textlist: [
      {
        name: "降低成本",
        img: require("../../assets/img/solute/05.png"),
        title:
          "采用天弛网络技术，利用天弛SDN高可用骨干网络和SD-WAN产品，主要应用使用专线，非主要应用使用备线网络，节约专线流量，有效降低成本",
        type: 1
      },
      {
        name: "优化路由和提高可用性",
        img: require("../../assets/img/solute/06.png"),
        title:
          "通过双网双用，让设备/线路/网络全面冗余，增强网络系统的安全性和可靠性",
        type: 2
      },
      {
        name: "资源高效利用",
        img: require("../../assets/img/solute/07.png"),
        title:
          "基于天弛骨干网络技术，让不同的应用走不同的网络线路，充分利用企业的现有网络资源，提升网络带宽利用率",
        type: 3
      },
      {
        name: "一站式服务",
        img: require("../../assets/img/solute/08.png"),
        title:
          "天弛提供线路和设备申请/安装/调试/运维等一站式服务，7*24小时的专家运维团队售后支持服务，快速响应客户的需求，解决问题",
        type: 4
      }
    ],
    serve: "企业私有网服务",
    serviceList: [
      {
        img: require("../../assets/img/solute/alile.png"),
        title: "灵活组网",
        name:
          "可根据企业不同分支机构的地域分布、规模大小以及实际网络需求等，提供灵活的组网方式；可通过不同的接入方式接入到天弛的POP点，可接受运营商专线，裸纤，SD-WAN，机房内跳线等不同的接入方式"
      },
      {
        img: require("../../assets/img/solute/global.png"),
        title: "服务范围覆盖全球",
        name:
          "网络覆盖全球的100多家数据中心节点、是30+IDC服务商是合作伙伴关系，构建的庞大资源池，整合骨干网络资源，帮助企业实现大陆及海外各自区域内的网络能力的延伸，并为企业提供优质的网络体验"
      },
      {
        img: require("../../assets/img/solute/usebale.png"),
        title: "线路稳定、可用率高",
        name:
          "绕过公共互联网的不可靠性，提供稳定的网络访问速度，并通过路由优化与协议优化方式保证服务的高可用性，可用率可到99.95%"
      },
      {
        img: require("../../assets/img/solute/network.png"),
        title: "统一的网络管理",
        name:
          "企业总部与分支机构的网络形成一个完整的网络，便于全程监控和实现二层网络故障自切换，实现了企业网络的统一管控"
      }
    ]
  },
  // 关于我们
  company: {
    title: "天弛网络",
    text: "打造领先的生态网络服务",
    header: "北京天弛网络有限公司",
    about: "关于我们",
    aboutList: [
      {
        name: "成立于2012年5月，致力于打造国内高端的电信增值业务服务商"
      },
      {
        name:
          "经营业务包括：国内互联网接入、国内企业VPN、DC-DC直连、DC-Cloud直连、SD-WAN连接、企业网络代维等服务"
      },
      {
        name: "在中国并提供基于SD-WAN的混合式云VPN的接入服务"
      },
      {
        name: "北京、 广州 、上海提供三地NOC运维团队，7*24*365全方位运维服务"
      },
      {
        name: "国内超过30家渠道同行业合作模式，打造全方位开放式生态合作模式"
      },
      {
        name: "具备国内固网传输和增值业务运营牌照"
      }
    ],
    identity: "资质认证",
    textlist: [
      {
        name: "ISO 9001 质量管理体系证书",
        img: require("../../assets/img/us/identify01.png")
      },
      {
        name: "计算机软件著作权登记证书",
        img: require("../../assets/img/us/identify02.png")
      },
      {
        name: "ICP增值电信业务许可证",
        img: require("../../assets/img/us/identify03.png")
      },
      {
        name: "实用新型专利证书",
        img: require("../../assets/img/us/identify04.png")
      }
    ],
    identify: [
      {
        name: "中关村高新技术企业",
        img: require("../../assets/img/us/identify05.jpg")
      },
      {
        name: "国家高新技术认定企业",
        img: require("../../assets/img/us/identify06.png")
      }
    ],
    advantage: "合作伙伴",
    look: "查看更多",
    retract: "收起",
    serve: "联系我们",
    connect: [
      {
        name: "北京总部",
        title: "Beijing headquarters",
        img: require("../../assets/img/us/01.png")
        // add:"北京市朝阳区酒仙桥东路9号院A5楼4层"
      },
      {
        name: "深圳办事处",
        title: "Shenzhen office",
        img: require("../../assets/img/us/02.png")
        // add:"广东省深圳市南山区科研路9号比克科技大厦19层1901F"
      },
      {
        name: "上海办事处",
        title: "Shanghai Office",
        img: require("../../assets/img/us/03.png")
        // add:"上海市徐汇区田林路388号 新业大厦 801"
      },
      {
        name: "香港办事处",
        title: "HongKong Company",
        img: require("../../assets/img/us/04.png")
        // add:"香港九龙旺角花园街2-16号好景商业中心12楼19室"
      }
      // {
      //   imgs: require("../../assets/img/us/04.png"),
      //   call: require("../../assets/img/us/CALL us.png"),
      //   phone: "7*24*365小时保障电话：",
      //   componey:"公司名：北京天弛网络有限公司",
      //   tel: "400-8768-711",
      //   add: "地址：北京市朝阳区酒仙桥东路9号院A5楼4层"
      // }
    ],
    map: "(示例图)"
  },
  promise: {
    title: "天弛网络坚持合作",
    text: "服务至上、创新务实、以诚为本",
    header: "服务体系",
    textlist: [
      {
        name: "网管保障服务",
        litext: [
          {
            title: "24 x 7 主动式监控设备与链路"
          },
          {
            title: "问题根源分析和故障管理"
          },
          {
            title: "性能、配置、资产管理"
          },
          {
            title: "网络动态分析、报表、建议"
          }
        ],
        type: 1
      },
      {
        name: "设备维护服务",
        litext: [
          {
            title: "多厂家产品的现场和备件服务"
          },
          {
            title: "事件收集、关联、上报"
          },
          {
            title: "远程配置"
          },
          {
            title: "安全防护报告"
          },
          {
            title: "现场工程师"
          }
        ],
        type: 3
      }
    ],
    textlists: [
      {
        name: "电话技术支持服务",
        litext: [
          {
            title: "全年365天，每天7×24 400号服务热线"
          },
          {
            title: "多厂家产品支持，单一联络点"
          },
          {
            title: "问题上报"
          }
        ],
        type: 2
      },
      {
        name: "故障处理相应SLA指标",
        litext: [
          {
            title: "首通故障响应电话——10分钟"
          },
          {
            title: "首封故障邮件——30分钟"
          },
          {
            title: "故障进度反馈——60分钟"
          }
        ],
        type: 4
      }
    ]
  },
  // 价格
  price: {
    title: "连接一触即发",
    header: "开启您的连接之旅",
    btnstart: "创建起点",
    btnend: "创建终点",
    taptitle: "查询价格",
    texttitle: "测试线路",
    band: "带宽范围：",
    bandrange: [
      {
        id: "1",
        name: "小于",
        names: "100M",
        namesnum1: "",
        namesnum2: "100"
      },
      {
        id: "2",
        name: "100M",
        names: "-500M",
        namesnum1: "100",
        namesnum2: "500"
      },
      {
        id: "3",
        name: "500M",
        names: "-1G",
        namesnum1: "500",
        namesnum2: "1000"
      },
      {
        id: "4",
        name: "大于",
        names: "1G",
        namesnum1: "1000",
        namesnum2: ""
      }
    ],
    selectband: "选择带宽：",
    radio: "其他需求",
    radios: "提交查看价格",
    detail: "配置详情",
    startconfig: "起点配置：",
    cloudtype: "云类型：",
    country: "国家：",
    area: "地区：",
    data: "数据中心：",
    endconfig: "终点配置：",
    basisconfig: "基础配置：",
    bandline: "宽带：",
    monthmoney: "月租价：",
    none: "未找到该线路价格",
    moneydetail: "价格明细：",
    linemoney: "线路费用：",
    unit: "元/月",
    cloudmoneyall: "云端口费用(总)：",
    nonecloud: "未找到该云价格",
    nonecurmoney: "一次性服务费：",
    ele: "元",
    tel: "以上价格仅供参考，详情致电：400-8768-711",
    relocation: "重新配置",
    aftersale: "提交售后",
    packnum: "输入包数：",
    packtext: "包数：",
    loss: "丢包率：",
    overtime: "延时：",
    carry: "执行",
    reset: "重置",
    month: "/月"
  },
  pricedialog: {
    // 提交成功
    dialogtext: "提交成功",
    text:
      "小主，我们已收到您的资源请求信息，将在48小时与您联系，祝你生活愉快！",
    config: "资源配置如下：",
    startdeploy: "起点配置：",
    enddeploy: "终点配置：",
    basisdeploy: "基础配置：",
    refermoney: "价格（RMB）：",
    // 其他需求
    require: "提交需求",
    theme: "需求主题：",
    contacts: "联系人：",
    phone: "手机号：",
    remarks: "备注：",
    radiobtn:
      "注：我们收到您的需求后，将在第一时间为您处理，保持您的通话畅通，请您耐心等待！",
    btn: "发送需求",
    // 创建起点-公有云和数据中心
    dialogTextStart: "创建起点",
    cloudtitle: "公有云",
    datatitle: "数据中心",
    cloudtype: "云类型：",
    country: "国家",
    city: "城市",
    dataheader: "数据中心",
    back: "上一步",
    success: "确定",
    china: "中国",
    // 创建终点-公有云和数据中心
    dialogTextEnd: "创建终点"
  },
  map: {
    num1: "30+",
    datacity: "全球数据城市",
    num2: "100+",
    datacenter: "全球数据中心",
    num3: "1500+",
    dataport: "全球数据端口",
    tips: "温馨提示：",
    tipsone: "本报价均为我方资源可达节点",
    tipstwo: "本报价均不包含客户至数据中心节点最后一公里和楼内跳线"
  },
  // 中国地图
  mapworld: {
    data: [
      { name: "北京", value: ["116.3979471", "39.9081726"] },

      { name: "上海", value: ["121.4692688", "31.2381763"] },

      { name: "天津", value: ["117.2523808", "39.1038561"] },

      { name: "重庆", value: ["106.548425", "29.5549144"] },

      { name: "河北", value: ["114.4897766", "38.0451279"] },

      { name: "山西", value: ["112.5223053", "37.8357424"] },

      { name: "辽宁", value: ["123.4116821", "41.7966156"] },

      { name: "吉林", value: ["125.3154297", "43.8925629"] },

      { name: "黑龙江", value: ["126.6433411", "45.7414932"] },

      { name: "浙江", value: ["120.1592484", "30.265995"] },

      { name: "福建", value: ["119.2978134", "26.0785904"] },

      { name: "山东", value: ["117.0056", "36.6670723"] },

      { name: "河南", value: ["113.6500473", "34.7570343"] },

      { name: "湖北", value: ["114.2919388", "30.5675144"] },

      { name: "湖南", value: ["112.9812698", "28.2008247"] },

      { name: "广东", value: ["113.2614288", "23.1189117"] },

      { name: "海南", value: ["110.3465118", "20.0317936"] },

      { name: "四川", value: ["104.0817566", "30.6610565"] },

      { name: "贵州", value: ["106.7113724", "26.5768738"] },

      { name: "云南", value: ["102.704567", "25.0438442"] },

      { name: "江西", value: ["115.8999176", "28.6759911"] },

      { name: "陕西", value: ["108.949028", "34.2616844"] },

      { name: "青海", value: ["101.7874527", "36.6094475"] },

      { name: "甘肃", value: ["103.7500534", "36.0680389"] },

      { name: "广西", value: ["108.3117676", "22.8065434"] },

      { name: "新疆", value: ["87.6061172", "43.7909393"] },

      { name: "内蒙古", value: ["111.6632996", "40.8209419"] },

      { name: "西藏", value: ["91.1320496", "29.657589"] },

      { name: "宁夏", value: ["106.2719421", "38.4680099"] },

      { name: "台湾", value: ["120.9581316", "23.8516062"] },

      { name: "香港", value: ["114.139452", "22.391577"] },

      { name: "澳门", value: ["113.5678411", "22.167654"] },

      { name: "安徽", value: ["117.2757034", "31.8632545"] },

      { name: "江苏", value: ["118.7727814", "32.0476151"] },

      { name: "广州", value: ["113.5107", "23.2196"] },
      {
        name: "石家庄",
        value: [114.4995, 38.1006]
      },
      {
        name: "杭州",
        value: [119.5313, 29.8773]
      },
      {
        name: "廊坊",
        value: [116.521, 39.0509]
      },
      {
        name: "南京",
        value: [118.8062, 31.9208]
      },
      {
        name: "武汉",
        value: [114.3896, 30.6628]
      },
      {
        name: "深圳",
        value: [114.5435, 22.5439]
      },
      {
        name: "无锡",
        value: [120.3442, 31.5527]
      },
      {
        name: "日本",
        value: [139.252924, 39.204824]
      },
      {
        name: "韩国",
        value: [127.766922, 35.907757]
      },
      {
        name: "法国",
        value: [2.213749, 45.227638]
      },
      {
        name: "德国",
        value: [14.451526, 48.165691]
      },
      {
        name: "美国",
        value: [-95.712891, 37.09024]
      },
      {
        name: "英国",
        value: [-2.235973, 56.378051]
      },
      {
        name: "荷兰",
        value: [5.291265999999999, 52.132633]
      },
      {
        name: "新加坡",
        value: [101.975766, 4.210484]
      },
      {
        name: "成都",
        value: [103.9526, 30.7617]
      },
      {
        name: "苏州",
        value: [120.6519, 31.3989]
      }
    ],
    mapdatas: [
      {
        name: "上海",
        value: [121.48, 31.22],
        data: ""
      },
      {
        name: "广州",
        value: [113.5107, 23.2196],
        data: ""
      },
      {
        name: "深圳",
        value: [114.5435, 22.5439],
        data: ""
      },
      {
        name: "北京",
        value: [116.46, 39.92],
        data: ""
      },
      {
        name: "杭州",
        value: [119.5313, 29.8773],
        data: ""
      },
      {
        name: "石家庄",
        value: [114.4995, 38.1006],
        data: ""
      },
      {
        name: "武汉",
        value: [114.3896, 30.6628],
        data: ""
      },
      {
        name: "廊坊",
        value: [116.521, 39.0509],
        data: ""
      },
      {
        name: "南京",
        value: [118.8062, 31.9208],
        data: ""
      },
      {
        name: "成都",
        value: [103.9526, 30.7617],
        data: ""
      },
      {
        name: "苏州",
        value: [120.6519, 31.3989],
        data: ""
      }
    ],
    mapdatanew: [
      {
        name: "上海",
        value: [121.48, 31.22],
        data: "上海新业"
      },
      {
        name: "广州",
        value: [113.5107, 23.2196],
        data: "广州华新园"
      },
      {
        name: "深圳",
        value: [114.5435, 22.5439],
        data: "深圳长虹"
      },
      {
        name: "北京",
        value: [116.46, 39.92],
        data: "北京夕照寺"
      },
      {
        name: "杭州",
        value: [119.5313, 29.8773],
        data: "杭州东方电子"
      },
      {
        name: "石家庄",
        value: [114.4995, 38.1006],
        data: "石家庄中信"
      },
      {
        name: "武汉",
        value: [114.3896, 30.6628],
        data: "中信武汉"
      },
      {
        name: "廊坊",
        value: [116.521, 39.0509],
        data: "河北廊坊高速机房"
      },
      {
        name: "南京",
        value: [118.8062, 31.9208],
        data: "中信南京"
      },
      {
        name: "成都",
        value: [103.9526, 30.7617],
        data: "成都鹏博士"
      },
      {
        name: "苏州",
        value: [120.6519, 31.3989],
        data: "苏州国科"
      }
    ]
  },
  geoCoordMap: {
    上海: [121.4648, 31.2891],
    东莞: [113.8953, 22.901],
    东营: [118.7073, 37.5513],
    中山: [113.4229, 22.478],
    临汾: [111.4783, 36.1615],
    临沂: [118.3118, 35.2936],
    丹东: [124.541, 40.4242],
    丽水: [119.5642, 28.1854],
    乌鲁木齐: [87.9236, 43.5883],
    佛山: [112.8955, 23.1097],
    保定: [115.0488, 39.0948],
    兰州: [103.5901, 36.3043],
    包头: [110.3467, 41.4899],
    北京: [116.4551, 40.2539],
    北海: [109.314, 21.6211],
    南京: [118.8062, 31.9208],
    南宁: [108.479, 23.1152],
    南昌: [116.0046, 28.6633],
    南通: [121.1023, 32.1625],
    厦门: [118.1689, 24.6478],
    台州: [121.1353, 28.6688],
    合肥: [117.29, 32.0581],
    呼和浩特: [111.4124, 40.4901],
    咸阳: [108.4131, 34.8706],
    哈尔滨: [127.9688, 45.368],
    唐山: [118.4766, 39.6826],
    嘉兴: [120.9155, 30.6354],
    大同: [113.7854, 39.8035],
    大连: [122.2229, 39.4409],
    天津: [117.4219, 39.4189],
    太原: [112.3352, 37.9413],
    威海: [121.9482, 37.1393],
    宁波: [121.5967, 29.6466],
    宝鸡: [107.1826, 34.3433],
    宿迁: [118.5535, 33.7775],
    常州: [119.4543, 31.5582],
    广州: [113.5107, 23.2196],
    廊坊: [116.521, 39.0509],
    延安: [109.1052, 36.4252],
    张家口: [115.1477, 40.8527],
    徐州: [117.5208, 34.3268],
    德州: [116.6858, 37.2107],
    惠州: [114.6204, 23.1647],
    成都: [103.9526, 30.7617],
    扬州: [119.4653, 32.8162],
    承德: [117.5757, 41.4075],
    拉萨: [91.1865, 30.1465],
    无锡: [120.3442, 31.5527],
    日照: [119.2786, 35.5023],
    昆明: [102.9199, 25.4663],
    杭州: [119.5313, 29.8773],
    枣庄: [117.323, 34.8926],
    柳州: [109.3799, 24.9774],
    株洲: [113.5327, 27.0319],
    武汉: [114.3896, 30.6628],
    汕头: [117.1692, 23.3405],
    江门: [112.6318, 22.1484],
    沈阳: [123.1238, 42.1216],
    沧州: [116.8286, 38.2104],
    河源: [114.917, 23.9722],
    泉州: [118.3228, 25.1147],
    泰安: [117.0264, 36.0516],
    泰州: [120.0586, 32.5525],
    济南: [117.1582, 36.8701],
    济宁: [116.8286, 35.3375],
    海口: [110.3893, 19.8516],
    淄博: [118.0371, 36.6064],
    淮安: [118.927, 33.4039],
    深圳: [114.5435, 22.5439],
    清远: [112.9175, 24.3292],
    温州: [120.498, 27.8119],
    渭南: [109.7864, 35.0299],
    湖州: [119.8608, 30.7782],
    湘潭: [112.5439, 27.7075],
    滨州: [117.8174, 37.4963],
    潍坊: [119.0918, 36.524],
    烟台: [120.7397, 37.5128],
    玉溪: [101.9312, 23.8898],
    珠海: [113.7305, 22.1155],
    盐城: [120.2234, 33.5577],
    盘锦: [121.9482, 41.0449],
    石家庄: [114.4995, 38.1006],
    福州: [119.4543, 25.9222],
    秦皇岛: [119.2126, 40.0232],
    绍兴: [120.564, 29.7565],
    聊城: [115.9167, 36.4032],
    肇庆: [112.1265, 23.5822],
    舟山: [122.2559, 30.2234],
    苏州: [120.6519, 31.3989],
    莱芜: [117.6526, 36.2714],
    菏泽: [115.6201, 35.2057],
    营口: [122.4316, 40.4297],
    葫芦岛: [120.1575, 40.578],
    衡水: [115.8838, 37.7161],
    衢州: [118.6853, 28.8666],
    西宁: [101.4038, 36.8207],
    西安: [109.1162, 34.2004],
    贵阳: [106.6992, 26.7682],
    连云港: [119.1248, 34.552],
    邢台: [114.8071, 37.2821],
    邯郸: [114.4775, 36.535],
    郑州: [113.4668, 34.6234],
    鄂尔多斯: [108.9734, 39.2487],
    重庆: [107.7539, 30.1904],
    金华: [120.0037, 29.1028],
    铜川: [109.0393, 35.1947],
    银川: [106.3586, 38.1775],
    镇江: [119.4763, 31.9702],
    长春: [125.8154, 44.2584],
    长沙: [113.0823, 28.2568],
    长治: [112.8625, 36.4746],
    阳泉: [113.4778, 38.0951],
    青岛: [120.4651, 36.3373],
    韶关: [113.7964, 24.7028],
    吐鲁番: [89.18596, 42.94244],
    那曲: [92.05136, 31.47614],
    吕梁: [111.15081, 37.51761],
    伊春: [128.669, 47.72582],
    呼伦贝尔: [119.73572, 49.21336],
    嘉峪关: [98.33435281250001, 39.668377553435185],
    汉中: [107.03194, 33.06784]
  },
  GZData: [
    [
      [
        {
          name: "北京",
          value: [116.46, 39.92]
        },
        {
          name: "上海",
          value: [121.48, 31.22]
        }
      ],
      [
        {
          name: "武汉",
          value: [114.3896, 30.6628]
        },
        {
          name: "北京",
          value: [116.46, 39.92]
        }
      ],
      [
        {
          name: "上海",
          value: [121.48, 31.22]
        },
        {
          name: "深圳",
          value: [114.5435, 22.5439]
        }
      ],
      [
        {
          name: "上海",
          value: [121.48, 31.22]
        },
        {
          name: "广州",
          value: [113.5107, 23.2196]
        }
      ],
      [
        {
          name: "上海",
          value: [121.48, 31.22]
        },
        {
          name: "石家庄",
          value: [114.4995, 38.1006]
        }
      ],
      [
        {
          name: "杭州",
          value: [119.5313, 29.8773]
        },
        {
          name: "石家庄",
          value: [114.4995, 38.1006]
        }
      ],
      [
        {
          name: "上海",
          value: [121.48, 31.22]
        },
        {
          name: "武汉",
          value: [114.3896, 30.6628]
        }
      ],
      [
        {
          name: "上海",
          value: [121.48, 31.22]
        },
        {
          name: "廊坊",
          value: [116.521, 39.0509]
        }
      ],
      [
        {
          name: "上海",
          value: [121.48, 31.22]
        },
        {
          name: "南京",
          value: [118.8062, 31.9208]
        }
      ],
      [
        {
          name: "上海",
          value: [121.48, 31.22]
        },
        {
          name: "杭州",
          value: [119.5313, 29.8773]
        }
      ],
      [
        {
          name: "杭州",
          value: [119.5313, 29.8773]
        },
        {
          name: "广州",
          value: [113.5107, 23.2196]
        }
      ],
      [
        {
          name: "武汉",
          value: [114.3896, 30.6628]
        },
        {
          name: "广州",
          value: [113.5107, 23.2196]
        }
      ],
      [
        {
          name: "深圳",
          value: [114.5435, 22.5439]
        },
        {
          name: "石家庄",
          value: [114.4995, 38.1006]
        }
      ],
      [
        {
          name: "广州",
          value: [113.5107, 23.2196]
        },
        {
          name: "成都",
          value: [103.9526, 30.7617]
        }
      ],
      [
        {
          name: "成都",
          value: [103.9526, 30.7617]
        },
        {
          name: "北京",
          value: [116.46, 39.92]
        },
      ]
    ]
  ],
  // 世界地图
  mapworlds: {
    data: [
      { name: "北京", value: ["116.3979471", "39.9081726"] },

      { name: "上海", value: ["121.4692688", "31.2381763"] },

      { name: "天津", value: ["117.2523808", "39.1038561"] },

      { name: "重庆", value: ["106.548425", "29.5549144"] },

      { name: "河北", value: ["114.4897766", "38.0451279"] },

      { name: "山西", value: ["112.5223053", "37.8357424"] },

      { name: "辽宁", value: ["123.4116821", "41.7966156"] },

      { name: "吉林", value: ["125.3154297", "43.8925629"] },

      { name: "黑龙江", value: ["126.6433411", "45.7414932"] },

      { name: "浙江", value: ["120.1592484", "30.265995"] },

      { name: "福建", value: ["119.2978134", "26.0785904"] },

      { name: "山东", value: ["117.0056", "36.6670723"] },

      { name: "河南", value: ["113.6500473", "34.7570343"] },

      { name: "湖北", value: ["114.2919388", "30.5675144"] },

      { name: "湖南", value: ["112.9812698", "28.2008247"] },

      { name: "广东", value: ["113.2614288", "23.1189117"] },

      { name: "海南", value: ["110.3465118", "20.0317936"] },

      { name: "四川", value: ["104.0817566", "30.6610565"] },

      { name: "贵州", value: ["106.7113724", "26.5768738"] },

      { name: "云南", value: ["102.704567", "25.0438442"] },

      { name: "江西", value: ["115.8999176", "28.6759911"] },

      { name: "陕西", value: ["108.949028", "34.2616844"] },

      { name: "青海", value: ["101.7874527", "36.6094475"] },

      { name: "甘肃", value: ["103.7500534", "36.0680389"] },

      { name: "广西", value: ["108.3117676", "22.8065434"] },

      { name: "新疆", value: ["87.6061172", "43.7909393"] },

      { name: "内蒙古", value: ["111.6632996", "40.8209419"] },

      { name: "西藏", value: ["91.1320496", "29.657589"] },

      { name: "宁夏", value: ["106.2719421", "38.4680099"] },

      { name: "台湾", value: ["120.9581316", "23.8516062"] },

      { name: "澳门", value: ["113.5678411", "22.167654"] },

      { name: "安徽", value: ["117.2757034", "31.8632545"] },

      { name: "江苏", value: ["118.7727814", "32.0476151"] },

      { name: "广州", value: ["113.5107", "23.2196"] },
      { name: "香港", value: ["114.139452", "22.391577"] },
      {
        name: "日本",
        value: [139.252924, 39.204824]
      },
      {
        name: "韩国",
        value: [127.766922, 35.907757]
      },
      {
        name: "法国",
        value: [2.213749, 45.227638]
      },
      {
        name: "德国",
        value: [14.451526, 48.165691]
      },
      {
        name: "美国",
        value: [-95.712891, 37.09024]
      },
      {
        name: "英国",
        value: [-2.235973, 56.378051]
      },
      {
        name: "荷兰",
        value: [5.291265999999999, 52.132633]
      },
      {
        name: "新加坡",
        value: [101.975766, 4.210484]
      }
    ],
    mapdatas: [
      {
        name: "香港",
        value: [114.139452, 22.391577],
        data: ""
      },
      {
        name: "日本",
        value: [139.252924, 39.204824],
        data: ""
      },
      {
        name: "韩国",
        value: [127.766922, 35.907757],
        data: ""
      },
      {
        name: "法国",
        value: [2.213749, 45.227638],
        data: ""
      },
      {
        name: "德国",
        value: [14.451526, 48.165691],
        data: ""
      },
      {
        name: "美国",
        value: [-95.712891, 37.09024],
        data: ""
      },
      {
        name: "英国",
        value: [-2.235973, 56.378051],
        data: ""
      },
      {
        name: "荷兰",
        value: [5.291265999999999, 52.132633],
        data: ""
      },
      {
        name: "新加坡",
        value: [101.975766, 4.210484],
        data: ""
      }
    ],
    mapdatanew: [
      {
        name: "香港",
        value: [114.139452, 22.391577],
        data: ""
      },
      {
        name: "日本",
        value: [139.252924, 39.204824],
        data: ""
      },
      {
        name: "韩国",
        value: [127.766922, 35.907757],
        data: ""
      },
      {
        name: "法国",
        value: [2.213749, 45.227638],
        data: ""
      },
      {
        name: "德国",
        value: [14.451526, 48.165691],
        data: ""
      },
      {
        name: "美国",
        value: [-95.712891, 37.09024],
        data: ""
      },
      {
        name: "英国",
        value: [-2.235973, 56.378051],
        data: ""
      },
      {
        name: "荷兰",
        value: [5.291265999999999, 52.132633],
        data: ""
      },
      {
        name: "新加坡",
        value: [101.975766, 4.210484],
        data: ""
      }
    ]
  },
  geoCoordMaps: {
    香港: [114.139452, 22.391577],
    日本: [139.252924, 39.204824],
    韩国: [127.766922, 35.907757],
    德国: [14.451526, 48.165691],
    荷兰: [5.291265999999999, 52.132633],
    新加坡: [101.975766, 4.210484],
    英国: [-2.235973, 56.378051],
    美国: [-95.712891, 37.09024],
    法国: [2.213749, 45.227638],
    上海: [121.4648, 31.2891],
    东莞: [113.8953, 22.901],
    东营: [118.7073, 37.5513],
    中山: [113.4229, 22.478],
    临汾: [111.4783, 36.1615],
    临沂: [118.3118, 35.2936],
    丹东: [124.541, 40.4242],
    丽水: [119.5642, 28.1854],
    乌鲁木齐: [87.9236, 43.5883],
    佛山: [112.8955, 23.1097],
    保定: [115.0488, 39.0948],
    兰州: [103.5901, 36.3043],
    包头: [110.3467, 41.4899],
    北京: [116.4551, 40.2539],
    北海: [109.314, 21.6211],
    南京: [118.8062, 31.9208],
    南宁: [108.479, 23.1152],
    南昌: [116.0046, 28.6633],
    南通: [121.1023, 32.1625],
    厦门: [118.1689, 24.6478],
    台州: [121.1353, 28.6688],
    合肥: [117.29, 32.0581],
    呼和浩特: [111.4124, 40.4901],
    咸阳: [108.4131, 34.8706],
    哈尔滨: [127.9688, 45.368],
    唐山: [118.4766, 39.6826],
    嘉兴: [120.9155, 30.6354],
    大同: [113.7854, 39.8035],
    大连: [122.2229, 39.4409],
    天津: [117.4219, 39.4189],
    太原: [112.3352, 37.9413],
    威海: [121.9482, 37.1393],
    宁波: [121.5967, 29.6466],
    宝鸡: [107.1826, 34.3433],
    宿迁: [118.5535, 33.7775],
    常州: [119.4543, 31.5582],
    广州: [113.5107, 23.2196],
    廊坊: [116.521, 39.0509],
    延安: [109.1052, 36.4252],
    张家口: [115.1477, 40.8527],
    徐州: [117.5208, 34.3268],
    德州: [116.6858, 37.2107],
    惠州: [114.6204, 23.1647],
    成都: [103.9526, 30.7617],
    扬州: [119.4653, 32.8162],
    承德: [117.5757, 41.4075],
    拉萨: [91.1865, 30.1465],
    无锡: [120.3442, 31.5527],
    日照: [119.2786, 35.5023],
    昆明: [102.9199, 25.4663],
    杭州: [119.5313, 29.8773],
    枣庄: [117.323, 34.8926],
    柳州: [109.3799, 24.9774],
    株洲: [113.5327, 27.0319],
    武汉: [114.3896, 30.6628],
    汕头: [117.1692, 23.3405],
    江门: [112.6318, 22.1484],
    沈阳: [123.1238, 42.1216],
    沧州: [116.8286, 38.2104],
    河源: [114.917, 23.9722],
    泉州: [118.3228, 25.1147],
    泰安: [117.0264, 36.0516],
    泰州: [120.0586, 32.5525],
    济南: [117.1582, 36.8701],
    济宁: [116.8286, 35.3375],
    海口: [110.3893, 19.8516],
    淄博: [118.0371, 36.6064],
    淮安: [118.927, 33.4039],
    深圳: [114.5435, 22.5439],
    清远: [112.9175, 24.3292],
    温州: [120.498, 27.8119],
    渭南: [109.7864, 35.0299],
    湖州: [119.8608, 30.7782],
    湘潭: [112.5439, 27.7075],
    滨州: [117.8174, 37.4963],
    潍坊: [119.0918, 36.524],
    烟台: [120.7397, 37.5128],
    玉溪: [101.9312, 23.8898],
    珠海: [113.7305, 22.1155],
    盐城: [120.2234, 33.5577],
    盘锦: [121.9482, 41.0449],
    石家庄: [114.4995, 38.1006],
    福州: [119.4543, 25.9222],
    秦皇岛: [119.2126, 40.0232],
    绍兴: [120.564, 29.7565],
    聊城: [115.9167, 36.4032],
    肇庆: [112.1265, 23.5822],
    舟山: [122.2559, 30.2234],
    苏州: [120.6519, 31.3989],
    莱芜: [117.6526, 36.2714],
    菏泽: [115.6201, 35.2057],
    营口: [122.4316, 40.4297],
    葫芦岛: [120.1575, 40.578],
    衡水: [115.8838, 37.7161],
    衢州: [118.6853, 28.8666],
    西宁: [101.4038, 36.8207],
    西安: [109.1162, 34.2004],
    贵阳: [106.6992, 26.7682],
    连云港: [119.1248, 34.552],
    邢台: [114.8071, 37.2821],
    邯郸: [114.4775, 36.535],
    郑州: [113.4668, 34.6234],
    鄂尔多斯: [108.9734, 39.2487],
    重庆: [107.7539, 30.1904],
    金华: [120.0037, 29.1028],
    铜川: [109.0393, 35.1947],
    银川: [106.3586, 38.1775],
    镇江: [119.4763, 31.9702],
    长春: [125.8154, 44.2584],
    长沙: [113.0823, 28.2568],
    长治: [112.8625, 36.4746],
    阳泉: [113.4778, 38.0951],
    青岛: [120.4651, 36.3373],
    韶关: [113.7964, 24.7028],
    吐鲁番: [89.18596, 42.94244],
    那曲: [92.05136, 31.47614],
    吕梁: [111.15081, 37.51761],
    伊春: [128.669, 47.72582],
    呼伦贝尔: [119.73572, 49.21336],
    嘉峪关: [98.33435281250001, 39.668377553435185],
    汉中: [107.03194, 33.06784]
  },
  GZDatas: [
    [
      [
        {
          name: "美国",
          value: [-95.712891, 37.09024]
        },
        {
          name: "荷兰",
          value: [5.291265999999999, 52.132633]
        }
      ],
      [
        {
          name: "香港",
          value: [114.139452, 22.391577]
        },
        {
          name: "美国",
          value: [-95.712891, 37.09024]
        }
      ],
      [
        {
          name: "日本",
          value: [139.252924, 39.204824]
        },
        {
          name: "香港",
          value: [114.139452, 22.391577]
        }
      ],
      [
        {
          name: "日本",
          value: [139.252924, 39.204824]
        },
        {
          name: "韩国",
          value: [127.766922, 35.907757]
        }
      ],
      [
        {
          name: "荷兰",
          value: [5.291265999999999, 52.132633]
        },
        {
          name: "香港",
          value: [114.139452, 22.391577]
        }
      ],
      [
        {
          name: "荷兰",
          value: [5.291265999999999, 52.132633]
        },
        {
          name: "韩国",
          value: [127.766922, 35.907757]
        }
      ],
      [
        {
          name: "韩国",
          value: [127.766922, 35.907757]
        },
        {
          name: "新加坡",
          value: [101.975766, 4.210484]
        }
      ],
      [
        {
          name: "韩国",
          value: [127.766922, 35.907757]
        },
        {
          name: "法国",
          value: [2.213749, 45.227638]
        }
      ],
      [
        {
          name: "英国",
          value: [-2.235973, 56.378051]
        },
        {
          name: "日本",
          value: [139.252924, 39.204824]
        }
      ],
      [
        {
          name: "英国",
          value: [-2.235973, 56.378051]
        },
        {
          name: "法国",
          value: [2.213749, 45.227638]
        }
      ],
      [
        {
          name: "新加坡",
          value: [101.975766, 4.210484]
        },
        {
          name: "德国",
          value: [14.451526, 48.165691]
        }
      ],
      [
        {
          name: "法国",
          value: [2.213749, 45.227638]
        },
        {
          name: "新加坡",
          value: [101.975766, 4.210484]
        }
      ],
      [
        {
          name: "法国",
          value: [2.213749, 45.227638]
        },
        {
          name: "德国",
          value: [14.451526, 48.165691]
        }
      ],
      [
        {
          name: "德国",
          value: [14.451526, 48.165691]
        },
        {
          name: "美国",
          value: [-95.712891, 37.09024]
        }
      ]
    ]
  ],
  // 个人资料
  personal: {
    selfcony: "个人资料",
    identify: "企业认证",
    name: "账户名：",
    popoverone: [
      {
        name: "②、支持数字、字母与下划线"
      },
      {
        name: "③、至少包含一个字母"
      },
      {
        name: "④、不支持汉字格式"
      }
    ],
    edit: "修改",
    save: "保存",
    cancel: "取消",
    tapbind: "点击绑定",
    albind: "已绑定",
    password: "登录密码：",
    phone: "手机号：",
    email: "邮箱：",
    times: "注册时间：",
    // 修改密码
    textMap: {
      editPwd: "修改密码",
      editPho: "修改手机号",
      editEma: "修改邮箱",
      bindEma: "邮箱绑定",
      bindPho: "手机号绑定"
    },
    oldPwd: "旧密码：",
    newPwd: "新密码：",
    conPwd: "确认新密码：",
    success: "确定",
    // 绑定手机号
    bindphone: "手机号",
    bindcode: "手机验证码",
    code: "获取验证码",
    bind: "提交",
    // 修改手机号
    stepData: [
      {
        label: "验证身份",
        value: 1
      },
      {
        label: "更改手机",
        value: 2
      }
    ],
    editphone: "请发送验证码到手机号",
    phonecode: "手机验证码",
    codefirst: "获取验证码",
    next: "下一步",
    newphone: "新手机号",
    newcode: "手机验证码",
    codephonesecond: "获取验证码",
    // 绑定邮箱
    bindemail: "邮箱",
    bindemailcode: "邮箱验证码",
    codes: "获取验证码",
    // 编辑邮箱
    stepEmail: [
      {
        label: "验证身份",
        value: 1
      },
      {
        label: "更改邮箱",
        value: 2
      }
    ],
    editemail: "请发送验证码到邮箱",
    emailcode: "邮箱验证码",
    codesfirst: "获取验证码",
    newemail: "新邮箱",
    newemailcode: "邮箱验证码",
    codesecond: "获取验证码"
  },
  selfdata: {
    name: "企业名称：",
    people: "公司联系人：",
    phone: "联系人手机号：",
    telphone: "公司预留电话：",
    address: "公司地址：",
    des: "备注：",
    save: "保存修改",
    num: "不能超过100个字"
  },
  user: {
    // 登录
    accout: "账号登录",
    name: "账号名/邮箱/手机号",
    password: "请输入密码",
    checked: "记住密码",
    forgetCode: "忘记密码？",
    login: "登录",
    regUser: "还没有账号？",
    signsty: "免费注册",
    // 退出登录
    message: "提示",
    loginout: "是否退出登录？",
    cancel: "取消",
    define: "确定",
    // 注册
    sign: "欢迎注册",
    already: "已有账号？",
    logintap: "直接登录",
    signphone: "手机号注册",
    signemail: "邮箱注册",
    success: "注册成功，请登录",
    backlogin: "返回登录",
    // 忘记密码
    forgetpassword: "找回密码",
    forgetphone: "手机号找回",
    forgetemail: "邮箱找回"
  },
  // 注册
  signphone: {
    // 手机号注册
    account: "账户名：",
    accountText: "请输入您的账户名",
    company: "企业名称：",
    companyText: "请输入您所在的公司",
    company_contact: "企业联系人：",
    company_contact_Text: "请输入联系人姓名",
    password: "密码：",
    passwordText: "请输入您设置的密码",
    popoversList: [
      {
        name: "①、6-20位字符"
      },
      {
        name: "②、必须包含数字、字母或下划线中的两种"
      }
    ],
    rePasswords: "确认密码：",
    rePasswordsText: "请再次输入您设置的密码",
    popoversr: "请保持两次密码的一致性",
    phone: "手机号码：",
    phoneText: "请输入您的手机号",
    drag: "请将滑块拖动到右侧",
    check: "验证成功",
    verifyStatus: "请拖动滑块进行验证",
    clause: "《天弛网站服务条款》",
    privacy: "《法律声明及隐私权政策》",
    care: "注：*为必填项",
    agree: "同意条款并注册",
    checkphone: "验证手机",
    nextText: "请发送验证码到手机",
    phonecode: "手机验证码：",
    codetext: "验证码",
    codeStr: "获取验证码",
    submit: "提交",
    // 邮箱注册
    email: "邮箱名称：",
    emailText: "请输入您的邮箱名称",
    checkemail: "验证邮箱",
    nextEmail: "请发送验证码到邮箱",
    emailcode: "邮箱验证码：",
    codeStrs: "获取验证码"
  },
  // 忘记密码
  forgectPhone: {
    phone: "手机号码",
    phoneplace: "请输入您的手机号",
    drag: "请将滑块拖动到右侧",
    check: "验证成功",
    verifyStatus: "请拖动滑块进行验证",
    text: "请发送验证码到手机：",
    phonecode: "手机验证码",
    phonetext: "请输入验证码",
    codeStr: "获取验证码",
    passwords: "输入密码",
    passwordText: "请输入您设置的密码",
    popovers: [
      {
        name: "①、6-20位字符"
      },
      {
        name: "②、必须包含数字、字母或下划线中的两种"
      }
    ],
    rePasswords: "确认新密码",
    rePasswordsText: "请再次输入您设置的密码",
    popoversr: "请保持两次密码的一致性",
    next: "下一步",
    define: "确定",
    // 下一步弹窗
    nonebind: "您还没有绑定手机号，请更换验证方式",
    // 修改成功弹窗
    passwordsuccess: "密码找回成功",
    back: "返回登录"
  },
  forgectEmail: {
    email: "邮箱名称",
    emailplace: "请输入您的邮箱名称",
    drag: "请将滑块拖动到右侧",
    check: "验证成功",
    verifyStatus: "请拖动滑块进行验证",
    text: "请发送验证码到邮箱：",
    emailcode: "邮箱验证码",
    emailtext: "请输入验证码",
    codeStrs: "获取验证码",
    passwords: "输入密码",
    passwordText: "请输入您设置的密码",
    popovers: [
      {
        name: "①、6-20位字符"
      },
      {
        name: "②、必须包含数字、字母或下划线中的两种"
      }
    ],
    rePasswords: "确认新密码",
    rePasswordsText: "请再次输入您设置的密码",
    popoversr: "请保持两次密码的一致性",
    next: "下一步",
    define: "确定",
    // 下一步弹窗
    nonebind: "您还没有绑定邮箱，请更换验证方式",
    // 修改成功弹窗
    passwordsuccess: "密码找回成功",
    back: "返回登录"
  },
  loginout: {
    title: "提示",
    out: "是否退出登录？",
    cancel: "取 消",
    bind: "确 定"
  },
  // 底部备案号
  record: {
    keep: "京ICP备18008832号-1",
    permit: "增值电信业务经营许可证：A2.B1-20130273"
  },
  // 校验文字
  checkvalid: {
    password: "请输入正确的密码",
    phone: "请输入正确的手机号码",
    same: "两次密码输入不一致，请重新输入",
    code: "请输入验证码",
    hd: "请将滑块拖动到右侧",
    email: "请输入正确的邮箱",
    codesuccess: "验证码发送成功",
    account: "请输入正确的账户名",
    company: "请输入公司名称",
    contact: "请输入公司联系人",
    logins: "登录成功",
    edit: "修改成功",
    oldPwd: "请输入正确的旧密码",
    newPwd: "请输入正确的新密码",
    conPwd: "请再次输入新密码",
    bind: "绑定成功",
    // 价格
    select: "请选择",
    pack: "请输入ping的包数",
    smallthan: "请输入大于零小于一万数值",
    packnum: "请输入正确的包数",
    loss: "努力读取中……",
    band: "请选择带宽",
    start: "请先创建起点",
    end: "请先创建终点",
    theme: "请输入需求主题",
    remarks: "请输入需求内容",
    contacts: "请输入联系人姓名",
    contactsphone: "请输入联系人手机号",
    text: "请输入文字",
    require: "需求发送成功",
    dialogText: "云端起点",
    selectcity: "请选择城市",
    selectdata: "请选择数据中心",
    dc: "DC端起点"
  },
  // 协议
  clause: {
    header: "天弛网络网站服务条款",
    time: "2019年12月版",
    qy: "前言",
    list: [
      {
        name: "欢迎访问天弛网络网站并使用我们提供的产品和服务。"
      },
      {
        name:
          "在完成注册程序或以任何方式使用天弛网络网站服务前，请您务必仔细阅读并透彻理解本天弛网络网站服务条款(以下或简称“服务条款”)，在确认充分理解后选择接受或不接受本服务条款；一旦您完成“同意条款并注册”或开始以其他方式使用天弛网络服务，即表明您已阅读并同意受本服务条款的约束。如您不同意本服务条款或其中任何条款约定，您应不再进行下一步或停止注册程序。"
      },
      {
        name:
          "天弛网络再次提示您审慎阅读、充分理解各条款内容，特别是限制或免除责任的相应条款，限制或免除责任条款将以加粗或其他醒目形式提示您注意。"
      },
      {
        name: "如果您未满18周岁，请在法定监护人的陪同下阅读本服务条款。"
      }
    ],
    //  一、
    one: "一、 签约主体以及协议范围",
    oneList: [
      {
        name:
          " 1.1. 天弛网络网站服务条款是您与北京天弛网络有限公司（“天弛网络”或者“我们”）就使用天弛网络网站服务（包含为您提供网站页面信息浏览、账户注册服务等）而订立的有效合约。"
      },
      {
        name: "天弛网络网站包含域名为http://www.tianchic.com/的网站。"
      },
      {
        name:
          "1.2.如您使用或购买天弛网络网站上某一具体服务，您可仍需确认具体服务对应的服务条款；请您审慎阅读、充分理解各条款内容，选择接受或不接受该服务条款。"
      }
    ],
    // 二、
    two: "二、账户的注册、使用与安全",
    numone: "2.1. 注册的资格",
    numoneList: [
      {
        name:
          "2.1.1. 您确认，在您完成注册程序或以其他天弛网络允许的方式实际使用本服务时，您应当是具备完全民事权利能力和完全民事行为能力的自然人、法人或其他组织（以下或简称为“您”）。"
      },
      {
        name:
          "2.1.2. 若您是未成年人或限制民事行为能力人，则您不具备前述主体资格，您及您的监护人应承担因您的不当注册行为而导致的一切后果。"
      },
      {
        name:
          " 2.3.天弛网络在此提示，您在使用天弛网络服务期间应当遵守中华人民共和国的法律，不得危害网络安全，不得利用天弛网络的服务从事他人侵犯名誉、隐私、知识产权和其他合法权益的活动。尽管有前述提示，天弛网络不对您使用天弛网络服务的用途和目的承担任何责任。"
      },
      {
        name:
          "2.1.3. 您还需确保您不是任何国家、国际组织或者地域实施的贸易限制、制裁或其他法律、规则限制的对象，否则您可能无法正常注册及使用天弛网络服务。"
      }
    ],
    numtwo: "2.2. 账户注册",
    numtwoList: [
      {
        name:
          "2.2.1.当您按照注册页面提示填写信息、阅读并同意本服务条款且完成全部注册程序后，您可获得天弛网络账户并成为天弛网络的用户。"
      },
      {
        name:
          "2.2.2. 您在注册时候设置或确认的账户名（“账户名称”）及您设置的密码，将在注册成功后成为您的账户（账户名称及密码合称“账户”）。        "
      },
      {
        name:
          "2.2.3. 您设置的账户名不得违反国家法律法规、天弛网络的管理规范或容易引起您与天弛网络身份的混淆，否则您的账户可能不能注册成功或天弛网络有权经通知您后予以注销。        "
      },
      {
        name:
          " 2.2.4. 您应当按照法律法规要求或按相应页面的提示，准确提供并及时更新您的账户信息，以使之真实、及时、完整和准确。如您提供的资料错误、不实、过时或不完整的，天弛网络可以向您发出询问及/或要求改正的通知，您应按照天弛网络的要求配合提供或者更新相关资料。因您填写的信息、资料不真实、不及时、不完整或不准确的，您应承担您不能使用天弛网络账户（不能注册成功、或账户被冻结、注销）或您在使用过程中的后果和损失。"
      },
      {
        name:
          "2.2.5. 天弛网络可能会就某些产品或服务的开通，要求您提供更多的身份资料和信息，做进一步的身份认证或资格验证，您的账户只有在通过这些认证和验证之后，方可获得使用相关产品或服务的资格。"
      },
      {
        name:
          " 2.2.6. 通常情况下，您的天弛网络账户是您在天弛网络网站进行一切活动的唯一身份标识，除非另有约定，每一个天弛网络账户都可以在本网站独立开展活动。但在下列情形下，天弛网络有权根据自己的判断，对同一及/或关联法律主体拥有的多个天弛网络账户进行统一处理，如根据不同天弛网络账户在注册、登录、使用中的关联信息，天弛网络判断其实际为同一用户。关联信息举例：同一证件、同一手机号、同一支付账号、同一设备、同一地址等。"
      }
    ],
    numthree: "2.3. 账户的使用和安全",
    numthreeList: [
      {
        name:
          " 2.3.1. 您有权使用您设定的账户登录天弛网络网站，进而使用天弛网络提供的其他服务。"
      },
      {
        name:
          "2.3.2. 天弛网络可能会以邮件、站内信、短信或电话等方式通知您服务进展情况以及提示您进行下一步的操作。在服务过程中您应当及时登录到天弛网络账户查看和进行交易操作。"
      },
      {
        name:
          " 2.3.3. 一个天弛网络账户仅能对应唯一的法律主体。除非有法律明文规定、司法裁定或者经天弛网络同意的情况下，您不得以任何方式转让、赠与或让他人继承您的天弛网络账户。"
      },
      {
        name:
          " 2.3.4. 您的账户和密码由您自行设置并由您保管，您须对您的天弛网络账户和密码保密。您需确保您在每个上网时段结束时，以正确步骤离开网站。"
      },
      {
        name:
          "2.3.5. 如发现他人未经授权使用您的天弛网络账户和密码，您应立即通知天弛网络；天弛网络将协助您冻结账户、更改密码或进行其他安全设置；您理解天弛网络对您的请求采取行动需要合理时间，天弛网络对在采取行动前已经产生的以及由您引发的后果（包括但不限于您的任何损失）不承担任何责任。"
      },
      {
        name:
          "2.3.6. 天弛网络亦会在网站服务端采取合理的技术措施保障账户的安全。"
      }
    ],
    // 三、
    three: "三、账户的冻结、注销及申诉",
    three_one: "3.1. 账户的冻结",
    three_one_list: [
      {
        name:
          "您的天弛网络账户（全部或部分权限或功能）在如下情况可能被冻结（如天弛网络帐户被限制资金转出功能等），天弛网络将通过邮件、站内信、短信或电话等方式通知您："
      },
      {
        name:
          " 3.1.1. 基于天弛网络网站或服务运行和交易安全的需要，如您发生或可能发生破坏或试图破坏天弛网络或天弛网络关联公司公平交易环境或正常交易秩序的，或任何使用含有天弛网络或天弛网络关联公司名称、品牌且对他人有误导嫌疑或任何使用某种中英文(全称或简称)、数字、域名等意图表示或映射与天弛网络或其关联公司具有某种关联的；"
      },
      {
        name:
          "3.1.2. 违反本服务条款、天弛网络网站的相关规则、规范（如交易规则、管理规范）、服务说明以及其他服务协议/条款的；"
      },
      {
        name: "3.1.3. 违反国家法律、法规、政策、法律文书的规定的；"
      },
      {
        name:
          "  3.1.4. 您遭到他人投诉，且对方已经提供了相关证据的，而您未按照我们的要求提供相反证据的；"
      },
      {
        name:
          "3.1.5. 天弛网络根据合理分析判断您的账户操作、收益、兑换等存在异常的；"
      },
      {
        name: "3.1.6. 国家有权机关要求进行的冻结的；"
      },
      {
        name:
          " 3.1.7. 天弛网络合理判断，您发生与如上行为性质相同或产生如上类似风险的其他情况的。"
      }
    ],
    three_two: "3.2. 账户的注销",
    three_two_list: [
      {
        name:
          "3.2.1. 如果出现如上第3.1条情形且情形严重的，或基于国家有权机关的要求，您的天弛网络账户（全部或部分权限或功能）将被注销，天弛网络将通过邮件、站内信、短信或电话等方式通知您。"
      },
      {
        name:
          "3.2.2. 您理解并同意，如您连续12个月未通过账户登录过天弛网络网站，且您的账户下不存在任何未到期的服务，天弛网络有权注销您的账户，您将不能再登录天弛网络网站。"
      }
    ],
    three_three: "3.3. 申诉",
    three_three_list: [
      {
        name:
          "发生前述账户冻结或注销情况下，您应及时予以关注并可以按照程序进行申诉等后续操作："
      },
      {
        name:
          " 3.3.1. 您通过申诉程序，向天弛网络申请解除上述冻结或注销的，为了您的账户安全，您应配合如实提供身份证明及相关资料，以及天弛网络要求的其他信息或文件，以便天弛网络进行核实。您应充分理解您的申诉并不必然被允许，天弛网络有权决定是否同意您的申诉请求。"
      },
      {
        name:
          "3.3.2. 您理解并同意，如果您拒绝如实提供身份证明及相关资料，或未能通过天弛网络审核，天弛网络有权长期冻结该等账户且长期限制账户部分或全部功能。"
      }
    ],
    // 四
    four: "四、网站服务及规范",
    four_one:
      "4.1．您有权享受天弛网络通过本网站提供的互联网技术服务和信息服务。您同时还应根据本服务条款以及您在购买具体服务时确认的相关条款和条件，履行及时付款、服务管理等责任。",
    four_two: "4.2. 您使用天弛网络的服务，您应保证：",
    four_one_text:
      " 4.2.1. 您使用天弛网络服务时将遵从国家、地方法律法规、行业惯例和社会公共道德，不会利用天弛网络提供的服务进行存储、发布、传播如下信息和内容：",
    four_one_list: [
      {
        name: "（ⅰ）违反国家法律法规政策的任何内容（信息）；"
      },
      {
        name: "（ⅱ）违反国家规定的政治宣传和/或新闻信息；"
      },
      {
        name: "（ⅲ）涉及国家秘密和/或安全的信息；"
      },
      {
        name: "（ⅳ）封建迷信和/或淫秽、色情、下流的信息或教唆犯罪的信息；"
      },
      {
        name: "（ⅴ）博彩有奖、赌博游戏；违反国家民族和宗教政策的信息；"
      },
      {
        name: "（ⅵ）妨碍互联网运行安全的信息；"
      },
      {
        name:
          "（ⅶ）侵害他人合法权益的信息和/或其他有损于社会秩序、社会治安、公共道德的信息或内容；"
      },
      {
        name:
          "（ⅷ）您同时承诺不得为他人发布上述不符合国家规定和/或本服务条款约定的信息内容提供任何便利，包括但不限于设置URL、BANNER链接等；"
      }
    ],
    four_one_text: [
      {
        name:
          "4.2.2. 不应出现任何破坏或试图破坏网络安全等的行为，包括不会利用技术或其他手段破坏或扰乱本网站及天弛网络其他客户的网站；"
      },
      {
        name:
          " 4.2.3. 您使用天弛网络网站的服务应符合本服务条款；如您违反上述保证，天弛网络除有权根据相关服务条款采取删除信息、中止服务、终止服务的措施，并有权冻结或注销您账户部分或全部功能。"
      }
    ],
    // 五、
    five: "五、隐私及个人信息的保护",
    five_list: [
      {
        name:
          "您的信任对天弛网络非常重要，天弛网络深知用户信息安全的重要性，天弛网络将按照法律法规要求，采取安全保护措施，保护您的用户信息安全可控。具体详见《法律声明及隐私权政策》。"
      }
    ],
    // 六、
    six: "六、知识产权",
    six_list: [
      {
        name:
          "6.1. 我们尊重知识产权，除非获得了您的同意，天弛网络不会擅自使用、修改、复制、公开传播、改变、散布、发行或公开发表您拥有知识产权的成果。"
      },
      {
        name:
          "6.2. 任何组织或个人认为天弛网络网站的网页内容，如转载文章、云市场服务商发布的商品信息等可能侵犯其合法权益的，可向天弛网络（http://www.tianchic.com/）提出书面权利通知，天弛网络将在收到知识产权权利人合格通知后依法尽快处理。"
      },
      {
        name:
          "6.3. 除非另行说明，天弛网络网站Logo、“天弛网络”等文字、图形及其组合，以及天弛网络网站的其他标识、徽记、天弛网络服务的名称、技术文档等的知识产权为天弛网络及其关联公司所有。"
      },
      {
        name:
          " 6.4. 您应尊重天弛网络和第三方的知识产权和其他合法权利/权益，并保证在发生侵犯前述权益的违法事件时，保护天弛网络及其雇员、股东、合作伙伴等免于因该等事件受到影响或损失，天弛网络保留在您侵犯天弛网络及/或其他第三方的合法权利/权益时终止向您提供服务并不退还任何款项的权利。"
      },
      {
        name: "其他具体信息详见《法律声明及隐私权政策》的法律声明部分。"
      }
    ],
    seven: "七、保密",
    seven_list: [
      {
        name:
          "天弛网络承诺对您注册账户时或使用天弛网络服务时提交或知悉的信息采取保密措施，不向第三方披露您的信息，除非："
      },
      {
        name:
          "7.1. 依据本服务条款或者您与天弛网络之间其他服务协议、合同、在线条款等规定可以提供的；"
      },
      {
        name: "7.2. 依据法律法规的规定或行政、司法等职权部门要求应当提供的；"
      },
      {
        name:
          "7.3. 在不违反本服务条款约定责任的前提下，该保密信息已经公开或能从公开领域获得。"
      }
    ],
    eight: "八、出口管制",
    eight_list: [
      {
        name:
          " 双方承诺遵守本协议所适用的联合国、中国、美国以及其他国家出口管制法律法规。您承诺不会将天弛网络提供的产品或服务用于适用的出口管制法律法规禁止的用途。非经相关主管机关许可，您及您授权使用天弛网络产品或服务的其他个人或实体不会通过天弛网络产品或服务向适用的出口管制法律法规禁止的实体或个人提供受管控的技术、软件或服务。"
      }
    ],
    nine: "九、信息安全事件",
    nine_list: [
      {
        name:
          " 天弛网络依据国家法律法规的要求、遵照相关安全事件处理标准管理信息安全事件。当发生涉及您相关资产的信息安全事件时，我们会依法及时将事件相关的情况通过邮件、信函、电话、推送通知等方式告知，您也可通过工单、客服电话、大客户经理电话等方式主动联系我们。"
      }
    ],
    ten: "十、责任范围和责任限制",
    ten_list: [
      {
        name:
          "10.1. 您了解并同意，您应承担因您使用本服务、违反本服务条款或在您的账户下采取的任何行动而导致的任何第三方索赔。如果由此引起天弛网络及其关联公司、员工、客户和合作伙伴被第三方索赔的，您应负责处理，并赔偿天弛网络及其关联公司由此遭受的全部损失和责任。"
      },
      {
        name:
          "10.2. 在适用法律许可的范围内，天弛网络不对与本服务条款有关或由本服务条款引起的任何间接的、惩罚性的、特殊的、派生的损失承担赔偿责任。"
      },
      {
        name:
          "10.3. 天弛网络在此提示，您在使用天弛网络服务期间应当遵守中华人民共和国的法律，不得危害网络安全，不得利用天弛网络的服务从事侵犯他人名誉、隐私、知识产权和其他合法权益的活动。天弛网络不对您使用天弛网络服务的违法或违约行为承担任何责任。"
      },
      {
        name:
          " 10.4. 天弛网络用户在天弛网络网站的论坛、社区以及云市场上自行上传、提供、发布相关信息，包括但不限于用户名称、公司名称、联系人及联络信息，相关图片、资讯等，均由用户自行提供，天弛网络的用户须对其提供的前述信息依法承担全部责任。"
      },
      {
        name:
          "10.5. 如果您通过使用天弛网络网站或获取来自第三方的任何产品或服务，例如，天弛网络云市场上的服务商依托云市场向您提供服务，服务商将对其提供的服务向您负责，天弛网络对此第三方服务不承担任何责任。"
      },
      {
        name:
          "10.6. 在某些情况下，为了帮助您更便捷的使用天弛网络的服务，天弛网络可能会展示天弛网络的参考代码或软件（如属于第三方开源软件，您则应遵守第三方开源软件的相关使用要求），基于相应展示页面的使用说明，该等软件可能允许您予以下载、进行二次开发等相关操作，您应理解并承诺，该等代码的知识产权属于天弛网络，您在使用时应明确表明权利人，同时，天弛网络不对您能否使用以及使用该等代码、软件的工作和后果负责。"
      }
    ],
    eleven: "十一、不可抗力和意外事件",
    eleven_list: [
      {
        name:
          "天弛网络的网站可能因为下列不可抗力或意外事件无法正常运行的，天弛网络不承担损害赔偿责任："
      },
      {
        name:
          "11.1. 因自然灾害、罢工、暴乱、战争、政府行为、司法行政命令等不可抗力因素；"
      },
      {
        name: "11.2. 因电力供应故障、通讯网络故障等公共服务因素；"
      },
      {
        name: "11.3. 经提前公告或通知的，天弛网络在短时间内的系统维护。"
      }
    ],
    twelve: "十二、 法律适用与管辖",
    twelve_list: [
      {
        name:
          "本服务条款之效力、解释、变更、执行与争议解决均适用中华人民共和国法律。因本服务条款产生之争议应提交至北京市仲裁委员会提出仲裁。"
      }
    ],
    thirteen: "十三、通知送达",
    thirteen_list: [
      {
        name:
          " 13.1. 您理解并同意，天弛网络可通过网页公告、电子邮件、站内信、短信、电话、系统消息以及即时通信等以上一种或多种通知方式向您发送通知，且天弛网络可以信赖您所提供的联系信息是完整、准确且当前有效的；上述通知在发送成功后视为已送达。"
      },
      {
        name:
          "13.2．除非本服务条款另有约定或天弛网络与您另行签订的协议明确规定了通知方式，您发送给天弛网络的通知，应当通过天弛网络对外正式公布的通信地址、传真号码、电子邮件地址等联系信息进行送达。"
      }
    ],
    fourteen: "十四、条款的更新和终止",
    fourteen_list: [
      {
        name:
          "14.1. 天弛网络有权对本服务条款及相应的服务规则内容进行变更，并将网页公告、电子邮件、站内信、短信等方式予以公告或通知；若您在本服务条款内容变更后继续使用本服务的，表示您已充分阅读、理解并接受修改后的内容，也将遵循修改后的条款内容。"
      },
      {
        name:
          "14.2. 在您的账户注销或经双方协商一致终止网站服务的，本服务条款终止。"
      }
    ],
    fifteen: "十五、其他",
    fifteen_list: [
      {
        name:
          "15.1. 本服务条款由本服务条款的内容、网站相关页面上展现的规则、规范，服务说明（含操作文档）和您点击确认的其他条款/条件组成，天弛网络和您均受其约束，且其中的相关名词可相互引用、解释。"
      },
      {
        name:
          "15.2. 本服务条款的章节标题仅为行文方便而设，不具有法律或合同效力。"
      },
      {
        name:
          " 15.3. 本服务条款任一条款被视为废止、无效或不可执行，该条款应视为可分的且不影响本服务条款及其他条款的有效性及可执行性。"
      },
      {
        name:
          "15.4. 天弛网络有权在天弛网络官网（http://www.tianchic.com/）上发布公告、发站内通知或邮件通知等方式将本服务的权利义务全部或者部分转移给天弛网络的关联公司。"
      },
      {
        name:
          "15.5. 除另有约定外，出于服务专业性考虑，天弛网络亦可能委托关联公司或其他法律主体向您提供天弛网络网站上一项或多项具体服务，同时您可能会与该等公司订立相关条款或条件，请您审慎阅读、充分理解条款和条件内容，选择接受或不接受该条款和条件。"
      },
      {
        name:
          "15.6. 本服务条款项下之保密条款、知识产权条款、法律适用与管辖条款以及性质上理应存续的其他条款（如对注册信息的真实性保证等），不因本条款的终止而失效。"
      }
    ]
  },
  privacy: {
    header: "法律声明及隐私权政策",
    time: "最近更新日期：2019年11月23日",
    times: "生效日期：2019年11月30日",
    ts: "提示条款",
    list: [
      {
        name:
          "您的信任对我们非常重要，我们深知用户信息安全的重要性，我们将按照法律法规要求，采取安全保护措施，保护您的用户信息安全可控。鉴此，天弛网络（或简称“我们”）制定本《法律声明及隐私权政策》（以下或简称“声明和政策”）并提醒您：在使用天弛网络网站的各项服务前，请您务必仔细阅读并透彻理解本《法律声明和隐私权政策》，在确认充分理解并同意后方使用相关产品和服务。一旦您开始使用天弛网络服务，将被视为对本声明和政策内容的接受和认可。"
      },
      {
        name:
          "如对本声明和政策内容有任何疑问、意见或建议，您可通过天弛网络的工单、建议提交平台与我们联系。"
      }
    ],
    content: "定义",
    contentList: [
      {
        name:
          "天弛网络网站：指天弛网络官网（域名为：http://www.tianchic.com/）。"
      },
      {
        name:
          "天弛网络：除非另有约定，指北京天弛网络有限公司是http://www.tianchic.com/以及天弛网络客户端的经营者。"
      },
      {
        name:
          "用户信息：用户信息是指您注册天弛网络网站账户，使用天弛网络的服务以及天弛网络为了向您提供服务，您提交的或者天弛网络收集的用户会员类信息，如姓名、联系方式等，具体详见隐私权政策第二条所述的信息。"
      },
      {
        name:
          "业务数据：不同于用户信息，是指天弛网络的用户利用天弛网络的服务上传、下载、分发等通过天弛网络的技术服务处理的数据。"
      }
    ],
    sm: "法律声明",
    //  一、
    one: "一、权利归属",
    oneList: [
      {
        name:
          " 1.1.天弛网络网站的Logo、“天弛网络”、“TESUCH”等文字、图形及其组合，以及天弛网络网站的其他标识、徽记、天弛网络服务的名称等为天弛网络及其关联公司在中国和其他国家的注册商标。未经天弛网络书面授权，任何人不得以任何方式展示、使用或做其他处理（包括但不限于复制、传播、展示、镜像、上传、下载），也不得向他人表明您有权展示、使用或做其他处理。"
      },
      {
        name:
          " 1.2.天弛网络网站所有的产品、服务、技术与所有程序（以下或简称“技术服务”）的知识产权均归属于天弛网络或归其权利人所有。"
      }
    ],
    // 二、
    two: "二、责任限制",
    numoneList: [
      {
        name:
          "2.1.天弛网络用户在天弛网络网站的论坛、社区以及云市场上，自行上传、提供、发布相关信息，包括但不限于用户名称、公司名称、联系人及联络信息，相关图片、资讯等，该等信息均由用户自行提供，天弛网络的用户须对其提供的任何信息依法承担全部责任。"
      },
      {
        name:
          "  2.2.天弛网络在此提示，您在使用天弛网络服务期间应当遵守中华人民共和国的法律，不得危害网络安全，不得利用天弛网络的服务从事他人侵犯名誉、隐私、知识产权和其他合法权益的活动。尽管有前述提示，天弛网络不对您使用天弛网络服务的用途和目的承担任何责任。"
      }
    ],
    // 三、
    three: "三、知识产权保护",
    three_one:
      "我们尊重知识产权，反对并打击侵犯知识产权的行为。任何组织或个人认为天弛网络网站的网页（含www.XXXXX.com网页内容以及客户端页面）内容（如转载文章、云市场服务商发布的商品信息等）可能侵犯其合法权益的，可以通过向天弛网络提出书面权利通知，天弛网络将在收到知识产权权利人合格通知后依法尽快处理。",
    hide: "隐私权政策",
    numthreeList: [
      {
        name:
          " 天弛网络（以下或称为“我们”）尊重并保护用户信息，并且将以高度勤勉和审慎的义务对待这些信息。在您使用了天弛网络网站提供的服务时，我们将按照本隐私权政策收集、处理及披露您的信息。我们希望通过本隐私权政策向您清晰地介绍我们对您信息的处理方式，因此我们建议您完整地阅读本隐私权政策，以帮助您了解维护自己隐私权的方式。如果您有任何疑问、意见或建议，请通过天弛网络提供的各种联系方式与我们联系。本政策将帮助您了解以下内容："
      },
      {
        name: "一、本协议的适用范围"
      },
      {
        name: "二、我们如何收集和使用您的用户信息"
      },
      {
        name: "三、我们如何共享、转让、公开披露您的用户信息"
      },
      {
        name: "四、用户业务数据和公开信息"
      },
      {
        name: "五、您如何管理您的用户信息"
      },
      {
        name: "六、我们如何保护和保存您的用户信息"
      },
      {
        name: "七、未成年人用户信息的特别约定"
      },
      {
        name: "八、隐私权政策的更新"
      },
      {
        name: "九、如何联系我们"
      }
    ],
    numberone: "一、本协议的适用范围",
    numberlist: [
      {
        name:
          " 1.1.本隐私权政策适用于天弛网络网站所有服务。服务包括向您提供页面浏览、网站登录服务，以及通过天弛网络网站向您提供的技术服务。"
      },
      {
        name:
          " 1.2.本隐私权政策不适用于其他第三方向您提供的服务。例如，天弛网络云市场上的服务商依托云市场向您提供服务时，您向服务商提供的信息不适用本隐私权政策。"
      },
      {
        name:
          " 1.3.需要特别说明的是，作为天弛网络的用户，若您利用天弛网络的技术服务，为您的用户再行提供服务，因您的业务数据属于您所有，您应当另行与您的用户约定隐私权政策。"
      }
    ],
    numbertwo: "二、我们如何收集和使用您的用户信息",
    number_one: "（一）我们收集您的用户信息的情形",
    number_onelist: [
      {
        name: "2.1.帮助您成为我们的会员"
      },
      {
        name:
          " 2.1.1.当您在天弛网络网站创建账户时，您须向我们提供会员名，设置、确认您的登录密码，提供您在中华人民共和国境内手机号码。您提交的手机号码用于您注册、登录、绑定账户、密码找回时接受验证码，并且作为您与天弛网络指定的联系方式之一，用来接受相关业务通知（如新品上线、服务变更等）。"
      },
      {
        name:
          "  2.1.2.在您注册完成天弛网络账户后，您可以在账户“基本资料”一栏中继续填写您的信息，包括（1）您的账户名称、单位名称等。"
      },
      {
        name:
          " 2.1.3.在您注册完成天弛网络账户后，您需在账号的管理控制台提交联系人信息，包括您指定联系人的邮箱、手机号码以及联系人的职位。天弛网络将通过如上信息向您推广、介绍产品，发送业务通知（含账单）或与您进行业务沟通。"
      },
      {
        name:
          "  2.1.4.如果您仅需使用天弛网络网站的浏览、搜索等基本服务，您不需要注册成为我们的会员及提供上述信息。"
      },
      {
        name: "2.2.向您提供技术服务"
      },
      {
        name:
          "2.2.1.根据中华人民共和国法律，在您使用具体的技术服务时，您应通过您的账号提供您的真实身份信息。"
      }
    ],
    number_two: "（二）我们使用您的用户信息的情形",
    number_twolist: [
      {
        name: "2.2.我们出于如下目的，使用您提交以及我们收集的用户信息："
      },
      {
        name:
          "2.2.1. 为了向您提供服务，我们会向您发送信息、通知或与您进行业务沟通，包括但不限于为保证服务完成所必须的验证码、使用服务时所必要的推送通知；"
      },
      {
        name:
          "2.2.2. 为了维护、改进服务，向您提供更符合您个性化需求的信息展示，我们可能将来自天弛网络网站某项服务的用户信息与来自其他项服务的信息结合起来，做出特征模型并进行用户画像，向您展示、推送信息和可能的商业广告，包括但不限于关于天弛网络产品的新闻以及市场活动及优惠促销信息、天弛网络合作第三方的推广信息，或其他您可能感兴趣的内容。如果您不想接收我们给您发送的商业性电子信息，您可通过短信提示回复退订或根据信息中提供的退订方式予以退订；"
      },
      {
        name:
          "2.2.3. 我们可能以用户信息统计数据为基础，设计、开发、推广全新的产品及服务；我们会对我们的服务使用情况进行统计，并可能会与公众或第三方分享这些统计信息，但这些统计信息不包含您的任何身份识别信息；"
      },
      {
        name:
          "2.2.4. 为提高您使用我们及我们关联公司、合作伙伴提供服务的安全性，确保操作环境安全与识别账号异常状态，保护您或其他用户或公众的人身财产安全免遭侵害，更好地预防钓鱼网站、欺诈、网络漏洞、计算机病毒、网络攻击、网络侵入等安全风险，更准确地识别违反法律法规或天弛网络相关协议、规则的情况，我们可能使用您的会员信息、并整合设备信息、有关网络日志以及我们关联公司、合作伙伴合法分享的信息，来判断您账户及交易风险、进行身份验证、安全事件的检测及防范，并依法采取必要的记录、审计、分析、处置措施；"
      },
      {
        name:
          "2.2.5. 如超出收集用户信息时所声称的目的，或者在超出具有直接或合理关联的范围使用用户信息前，我们会再次向您告知并征得您的明示同意。"
      }
    ],
    numberthree: "三、我们如何共享、转让、公开披露您的用户信息",
    number_three: "3.1. 共享",
    number_threelist: [
      {
        name: "我们不会与其他组织和个人共享您的用户信息，但以下情况除外："
      },
      {
        name:
          "3.1.1.在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的用户信息；"
      },
      {
        name:
          "3.1.2.在法定情形下的共享：我们可能会根据法律法规规定、诉讼、仲裁解决需要，或按行政、司法机关依法提出的要求，对外共享您的用户信息；"
      },
      {
        name:
          "3.1.3.为了促成交易或协助解决争议，某些情况下只有共享您的用户信息，才能促成交易或处理您与他人的纠纷或争议，例如，在天弛网络云市场上创建的某一交易中，如交易任何一方履行或部分履行了交易义务并提出信息披露请求的，天弛网络有权决定向该用户提供其交易对方的联络方式等必要信息，以促成交易的完成；"
      },
      {
        name:
          "3.1.4.与授权合作伙伴共享：我们可能委托受信赖的合作伙伴来提供服务，因此我们可能会与合作伙伴共享您的某些用户信息，以提供更好的客户服务和优化用户体验。我们仅会出于合法、正当、必要、特定、明确的目的共享您的用户信息，并且只会共享提供服务所必要的用户信息。我们的合作伙伴无权将共享的用户信息用于任何其他用途。目前，我们的授权合作伙伴包括如下类型：供应商、服务提供商和其他合作伙伴。我们将信息发送给支持我们业务的供应商、服务提供商和其他合作伙伴，这些支持包括提供基础技术服务、提供咨询、分析等专业服务。对我们与之共享用户信息的公司、组织和个人，我们会与其签署严格的保密协议以及信息保护约定，要求他们按照我们的说明、本隐私权政策以及其他任何相关的保密和安全措施来处理用户信息。"
      }
    ],
    three_two: "3.2. 转让",
    three_two_list: [
      {
        name:
          "我们不会将您的用户信息转让给任何公司、组织和个人，但以下情况除外："
      },
      {
        name:
          "3.2.1. 在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的用户信息；"
      },
      {
        name:
          "3.2.2. 在天弛网络与其他法律主体者发生合并、收购或破产清算情形，或其他涉及合并、收购或破产清算情形时，如涉及到用户信息转让，我们会要求新的持有您用户信息的公司、组织继续受本政策的约束，否则我们将要求该公司、组织和个人重新向您征求授权同意。"
      }
    ],
    three_three: "3.3.公开披露",
    three_three_list: [
      {
        name: "我们仅会在以下情况下，公开披露您的用户信息："
      },
      {
        name:
          " 3.3.1.获得您明确同意或基于您的主动选择，我们可能会公开披露您的用户信息；"
      },
      {
        name:
          "3.3.2.或为保护天弛网络平台及其关联公司用户或公众的人身财产安全免遭侵害，我们可能依据适用的法律或天弛网络平台相关协议、规则披露关于您的用户信息。例如，若您作为云市场服务商销售假货或盗版商品，我们可能会公开披露您的店铺主体信息与处罚情况。"
      }
    ],
    three_four: "3.4.共享、转让、公开披露用户信息时事先征得授权同意的例外",
    three_four_list: [
      {
        name:
          "以下情形中，共享、转让、公开披露您的用户信息无需事先征得您的授权同意："
      },
      {
        name: "3.4.1.与国家安全、国防安全有关的；"
      },
      {
        name: "3.4.2.与公共安全、公共卫生、重大公共利益有关的；"
      },
      {
        name: "3.4.3.与犯罪侦查、起诉、审判和判决执行等有关的；"
      },
      {
        name:
          "3.4.4.出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；"
      },
      {
        name: "3.4.5.您自行向社会公众公开的个人信息；"
      },
      {
        name:
          " 3.4.6.从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。"
      }
    ],
    // 四
    four: "四、用户业务数据和公开信息",
    fourtext:
      "不同于您的用户信息，对于用户业务数据和公开信息，天弛网络将按如下方式处理：",
    four_one: "4.1.用户业务数据",
    four_one_list: [
      {
        name:
          "4.1.1.您通过天弛网络提供的服务，加工、存储、上传、下载、分发以及通过其他方式处理的数据，均为您的用户业务数据，您完全拥有您的用户业务数据。天弛网络作为云服务提供商，我们只会严格执行您的指示处理您的业务数据，除按与您协商一致或执行明确的法律法规要求外，不对您的业务数据进行任何非授权的使用或披露。"
      },
      {
        name:
          "4.1.2.您应对您的用户业务数据来源及内容负责，天弛网络提示您谨慎判断数据来源及内容的合法性。因您的用户业务数据内容违反法律法规、部门规章或国家政策而造成的全部结果及责任均由您自行承担。"
      },
      {
        name:
          "4.1.3.根据您与天弛网络协商一致，天弛网络在您选定的数据中心存储用户业务数据。天弛网络恪守对用户的安全承诺，根据适用的法律保护用户存储在天弛网络数据中心的数据。"
      }
    ],
    four_one_text: [
      {
        name:
          "4.2.2. 不应出现任何破坏或试图破坏网络安全等的行为，包括不会利用技术或其他手段破坏或扰乱本网站及天弛网络其他客户的网站；"
      },
      {
        name:
          " 4.2.3. 您使用天弛网络网站的服务应符合本服务条款；如您违反上述保证，天弛网络除有权根据相关服务条款采取删除信息、中止服务、终止服务的措施，并有权冻结或注销您账户部分或全部功能。"
      }
    ],
    four_two: "4.2.公开信息",
    four_two_list: [
      {
        name:
          "4.2.1.公开信息是指您公开分享的任何信息，任何人都可以在使用和未使用天弛网络网站服务期间查看或访问这些信息。例如您在天弛网络开发者论坛发布的信息。"
      },
      {
        name:
          "4.2.2.为使用天弛网络网站服务，可能存在您必须公开分享的信息。例如云市场为构建诚信交易环境，您的信用评价信息（星级、客户评价）需要被公开分享。若您是服务商（卖家），您应当根据适用的法律法规和天弛网络云市场规则的要求，公开分享企业或者自然人经营者的相关信息。"
      },
      {
        name:
          "4.2.3.在使用天弛网络网站的云市场进行交易时，您不可避免的要向交易对方或潜在的交易对方披露自己的个人信息，如联络方式或者邮政地址。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。您也可以通过我们的服务建立联系和相互分享。当您通过我们的服务创建交流、交易或分享时，您可以自主选择沟通、交易或分享的对象，作为能够看到您的联络方式、交流信息或分享内容等相关信息的第三方。如您发现自己的个人信息泄漏，尤其是您的账户或密码发生泄露，请您立即联络天弛网络客服，以便天弛网络采取相应措施。"
      }
    ],
    // 五、
    five: "五、您如何管理您的用户信息",
    five_list: [
      {
        name:
          "5.1.您可以登录天弛网络网站或客户端“管理控制台”查询、管理（变更、删除）使用天弛网络服务时而提交的基本业务信息（基本资料）和联系人信息。"
      },
      {
        name:
          "5.2. 如果您需要变更您天弛网络账户的信息，您需登录天弛网络网站进行信息修改。"
      },
      {
        name: "5.3. 在以下情形中，您可以向我们提出删除用户信息的请求："
      },
      {
        name: "5.3.1. 如果我们处理用户信息的行为违反法律法规；"
      },
      {
        name: "5.3.3. 如果我们处理个人信息的行为严重违反了与您的约定。"
      },
      {
        name:
          "5.4 每个业务功能需要一些基本的用户信息才能得以完成（见本隐私权政策第二条）。除此之外，您可以在与天弛网络客服联系给予或收回您的授权同意。当您收回同意后，我们将不再处理相应的用户信息。但您收回同意的决定，不会影响此前基于您的授权而开展的用户信息处理。"
      }
    ],

    seven: "六、我们如何保护和保存您的用户信息",
    seven_list: [
      {
        name:
          "6.1. 天弛网络非常重视您的信息安全。我们努力采取各种合理的物理、电子和管理方面的安全措施来保护您的用户信息。防止用户信息遭到未经授权访问、公开披露、使用、修改、损坏或丢失。我们会使用加密技术提高用户信息的安全性；我们会使用受信赖的保护机制防止用户信息遭到恶意攻击；我们会部署访问控制机制，尽力确保只有授权人员才可访问用户信息；以及我们会举办安全和隐私保护培训课程，加强员工对于保护用户信息重要性的认识。"
      },
      {
        name:
          " 6.2. 我们会采取合理可行的措施，尽力避免收集无关的用户信息。我们只会在达成本政策所述目的所需的期限内保留您的用户信息，除非受到法律的允许。超出上述用户信息保存期限后，我们会对您的个人信息进行删除或匿名化处理。"
      },
      {
        name:
          "6.3. 请使用复杂密码，协助我们保证您的账号安全。我们将尽力保障您发送给我们的任何信息的安全性。如果我们的物理、技术或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。"
      },
      {
        name:
          "6.4. 在不幸发生用户信息安全事件（泄露、丢失等）后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知用户信息主体时，我们会采取合理、有效的方式发布公告。"
      },
      {
        name:
          "6.5. 同时，我们还将按照监管部门要求，上报用户信息安全事件的处置情况。"
      },
      {
        name:
          "6.6. 我们将收集到的您的用户信息存放在中华人民共和国境内，如在符合适用法律规定的情形下因业务需要向境外传输个人信息的，我们会事先征得您的同意，并向您告知用户信息出境的目的、接收方、安全保障措施、安全风险等情况。"
      },
      {
        name:
          "6.7. 如出现天弛网络产品和服务停止运营的情形，我们会采取合理措施保护您用户信息安全，包括及时停止继续收集用户信息的活动；停止运营的通知将以逐一送达或公告的形式通知用户；并对所持有的个人信息进行删除或匿名化处理等。"
      }
    ],
    eight: "七、未成年人用户信息的特别约定",
    eight_list: [
      {
        name:
          "7.1.我们主要面向成人提供产品和服务。如您为未成年人，我们要求您请您的父母或监护人仔细阅读本隐私权政策，并在征得您的父母或监护人同意的前提下使用我们的服务或向我们提供信息。"
      },
      {
        name:
          "7.2.对于经父母或监护人同意使用我们的产品或服务而收集未成年人个人信息的情况，我们只会在法律法规允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用、共享、转让或披露此信息。"
      }
    ],
    nine: "八、隐私权政策的更新",
    nine_list: [
      {
        name: " 8.1. 我们的隐私权政策可能修订。"
      },
      {
        name:
          "8.2. 未经您明确同意，我们不会限制您按照本隐私权政策所应享有的权利。我们会在专门页面上发布对隐私权政策所做的任何修订。"
      },
      {
        name:
          "8.3. 对于重大修订，我们还会提供更为显著的通知（包括对于某些服务，我们会通过网站公示的方式进行通知甚至向您提供弹窗提示，说明隐私权政策的具体变更内容）。"
      },
      {
        name: "8.4. 本政策所指的重大变更包括但不限于："
      },
      {
        name:
          "8.4.1. 我们的服务模式发生重大变化。如处理用户信息的目的、处理的用户信息类型、用户信息的使用方式等；"
      },
      {
        name:
          " 8.4.2. 我们在控制权、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；"
      },
      {
        name: "8.4.3.用户信息共享、转让或公开披露的主要对象发生变化；"
      },
      {
        name: "8.4.4. 您参与用户信息处理方面的权利及其行使方式发生重大变化；"
      },
      {
        name:
          "8.4.5. 我们负责处理用户信息安全的责任部门、联络方式及投诉渠道发生变化时；"
      },
      {
        name: "8.4.6. 用户信息安全影响评估报告表明存在高风险时。"
      }
    ],
    ten: "九、如何联系我们",
    ten_list: [
      {
        name:
          "您对本声明和政策内容有任何疑问和意见，或者您对天弛网络对本隐私权政策的实践以及操作上有任何疑问和意见，您可通过天弛网络的工单、建议提交平台与我们联系。"
      }
    ]
  },
  // 新闻资讯
  news: {
    recent: "最近发布",
    label: "标签"
  },
  ...zhLocale
};

export default zh;
